(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8043],{

/***/ 48043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FeedComponent; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(9941);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Feed/PostSomething/index.tsx
var PostSomething = __webpack_require__(85284);
// EXTERNAL MODULE: ./src/components/Feed/NormalPost/index.tsx + 15 modules
var NormalPost = __webpack_require__(63254);
// EXTERNAL MODULE: ./src/components/Feed/PostSomethingMobile/index.tsx + 9 modules
var PostSomethingMobile = __webpack_require__(25706);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./src/store/slices/guestAccountDetailSlice.tsx
var guestAccountDetailSlice = __webpack_require__(33305);
// EXTERNAL MODULE: ./src/store/store.tsx + 6 modules
var store = __webpack_require__(74573);
// EXTERNAL MODULE: ./node_modules/antd/es/tabs/index.js + 23 modules
var tabs = __webpack_require__(44526);
// EXTERNAL MODULE: ./src/utils/auth.tsx
var auth = __webpack_require__(23174);
;// CONCATENATED MODULE: ./src/components/shared/NewLeftSidebar/InviteYourFriends/index.tsx
// @ts-nocheck






var TabPane = tabs/* default.TabPane */.Z.TabPane;
var social_facebook = /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
    src: "/assets/img/left-sidebar/fb.svg"
});
var social_twitter = /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
    src: "/assets/img/left-sidebar/twitter.svg"
});
var social_instagram = /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
    src: "/assets/img/left-sidebar/instagram.svg"
});
var social_linkedin = /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
    src: "/assets/img/left-sidebar/linkedin.svg"
});
var social_tiktok = /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
    src: "/assets/img/left-sidebar/tiktok.svg"
});
function InviteYourFriends(param) {
    var setIsModalVisible = param.setIsModalVisible;
    var onChange = function onChange(e) {};
    var dispatch = (0,store/* useAppDispatch */.T)();
    var user = (0,auth/* useAuth */.a)().user;
    var handleRedirect = function() {
        if (user) {
            setIsModalVisible(true);
        } else {
            dispatch((0,guestAccountDetailSlice/* guestAccountDetailSlice */.Y)({
                modal: "authModal",
                isOpen: true,
                id: {
                    media: "https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4",
                    modalFor: "login",
                    startWith: "loginModal"
                }
            }));
        }
    };
    var handleOk = function() {
        setIsModalVisible(false);
    };
    var handleCancel = function() {
        setIsModalVisible(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "invite-your-friend-details",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "invite-your-friend-heading",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "Invite your Friends!"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "invite-your-friend-profile-alignment",
                    onClick: handleRedirect,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "invite-your-friend-details-profile",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/img/feed-demo-1.png",
                                alt: "feed profile"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "invite-your-friend-details-profile",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/img/feed-demo-2.png",
                                alt: "feed profile"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "invite-your-friend-details-profile",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/img/feed-demo-3.png",
                                alt: "feed profile"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "invite-your-friend-details-profile",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/img/feed-demo-4.png",
                                alt: "feed profile"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "invite-your-friend-notes",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Friends who shop together, save together! Invite your buddies and let's snag deals as a team.\""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "invitation-send-button",
                    onClick: handleRedirect,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        children: "Send Invitation"
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/shared/NewLeftSidebar/NewFooter/index.tsx



function NewFooter() {
    var handleMove = function(url) {
        window.open(url);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "new-footer-section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "new-footer-top-details",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "new-footer-grid",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "new-footer-grid-item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/marketplace",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Sell with Us"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "new-footer-grid-item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/helpcenter/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Help Center"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "new-footer-grid-item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/policies/terms-of-use",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Term of Use"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "new-footer-grid-item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/policies/privacy-policy",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Privacy Policy"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "new-footer-grid-item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/policies/privacy-policy#cookies",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Cookie Policy"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "new-footer-grid-item",
                            onClick: function() {
                                return handleMove("https://about.bluejestic.com/");
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "About"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "new-footer-copy-right-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "\xa9 2025 Bluejestic. All rights reserved."
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/utils/getImageUrl.ts
var getImageUrl = __webpack_require__(26758);
;// CONCATENATED MODULE: ./src/components/shared/NewLeftSidebar/SidebarProfile/index.tsx




function SidebarProfile() {
    var ref, ref1, ref2;
    var user = (0,auth/* useAuth */.a)().user;
    var userCoverImage = (user === null || user === void 0 ? void 0 : (ref = user.coverImage) === null || ref === void 0 ? void 0 : ref.length) > 0 ? (0,getImageUrl/* default */.Z)((user === null || user === void 0 ? void 0 : user.coverImage) && ((ref1 = user === null || user === void 0 ? void 0 : user.coverImage[0]) === null || ref1 === void 0 ? void 0 : ref1.url)) : "https://images.unsplash.com/photo-1622557850710-d08a111d3476?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=667&q=80";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "feed-sidebar-profile-alignment",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "feed-sidebar-profile-details",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "feed-sidebar-profile-img",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (user === null || user === void 0 ? void 0 : user.logo_image) ? (0,getImageUrl/* default */.Z)(user === null || user === void 0 ? void 0 : user.logo_image) : "/assets/img/dummy-profile.svg",
                        alt: user === null || user === void 0 ? void 0 : (ref2 = user.profileImage) === null || ref2 === void 0 ? void 0 : ref2.alternativeText
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "feed-sidebar-profile-name",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                        children: [
                            (user === null || user === void 0 ? void 0 : user.firstName) ? user === null || user === void 0 ? void 0 : user.firstName : "Unnamed",
                            " ",
                            " ",
                            " ",
                            user === null || user === void 0 ? void 0 : user.lastName
                        ]
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/store/slices/manageModalSlice.tsx
var manageModalSlice = __webpack_require__(89013);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
;// CONCATENATED MODULE: ./src/components/shared/NewLeftSidebar/index.tsx










function NewLeftSidebar(param) {
    var setIsModalVisible = param.setIsModalVisible;
    var ref, ref1, ref2;
    var user = (0,auth/* useAuth */.a)().user;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var getAllState = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageModalData) === null || ref === void 0 ? void 0 : ref.data;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "feed-new-left-side-alignment",
        children: [
            user && /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarProfile, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "feed-new-sidebar-option-alignment",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: (getAllState === null || getAllState === void 0 ? void 0 : (ref = getAllState.lastModalData) === null || ref === void 0 ? void 0 : ref.modal) === "storesModal" ? "active-sidebar-option" : "",
                            onClick: function() {
                                dispatch((0,manageModalSlice/* fetchModalData */.w)({
                                    allModalData: (0,_to_consumable_array/* default */.Z)(getAllState === null || getAllState === void 0 ? void 0 : getAllState.allModalData).concat([
                                        {
                                            modal: "storesModal",
                                            isOpen: true,
                                            id: 0,
                                            modalFor: "mediumModal"
                                        }, 
                                    ]),
                                    lastModalData: getAllState === null || getAllState === void 0 ? void 0 : getAllState.lastModalData
                                }));
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M15.9167 8.58317H15.5933C14.9846 8.58317 14.4242 8.36734 13.9952 8.0087C13.5662 8.36734 13.0058 8.58317 12.3971 8.58317H11.598C10.9892 8.58317 10.4289 8.36734 9.99989 8.0087C9.57091 8.36734 9.01053 8.58317 8.40176 8.58317H7.6027C6.99393 8.58317 6.43355 8.36734 6.00457 8.0087C5.5756 8.36734 5.01522 8.58317 4.40645 8.58317H4.08341V16.6665H7.50008V11.6665C7.50008 11.2063 7.87318 10.8332 8.33341 10.8332H12.0834C12.5437 10.8332 12.9167 11.2063 12.9167 11.6665V16.6665H15.9167V8.58317ZM17.5834 7.98475V16.7498C17.5834 17.6243 16.8745 18.3332 16.0001 18.3332H4.00008C3.12563 18.3332 2.41675 17.6243 2.41675 16.7498V7.98494C1.95673 7.57634 1.66675 6.99145 1.66675 6.33552C1.66675 6.12177 1.69846 5.90923 1.76084 5.7043L2.63037 2.84782C2.84398 2.14608 3.49128 1.6665 4.2248 1.6665H15.775C16.5085 1.6665 17.1558 2.14608 17.3694 2.84782L18.2389 5.7043C18.4982 6.55614 18.21 7.42661 17.5834 7.98475ZM11.2501 16.6665V12.4998H9.16675V16.6665H11.2501ZM16.6445 6.18966L15.775 3.33317H4.2248L3.35527 6.18966C3.34073 6.23745 3.33341 6.28645 3.33341 6.33552C3.33341 6.64417 3.62356 6.9165 4.00692 6.9165H4.40645C4.84022 6.9165 5.17124 6.60581 5.17124 6.24984C5.17124 5.13873 6.83791 5.13873 6.83791 6.24984C6.83791 6.60581 7.16893 6.9165 7.6027 6.9165H8.40176C8.83553 6.9165 9.16655 6.60581 9.16655 6.24984C9.16655 5.13873 10.8332 5.13873 10.8332 6.24984C10.8332 6.60581 11.1642 6.9165 11.598 6.9165H12.3971C12.8308 6.9165 13.1619 6.60581 13.1619 6.24984C13.1619 5.13873 14.8285 5.13873 14.8285 6.24984C14.8285 6.60581 15.1596 6.9165 15.5933 6.9165H15.9929C16.0601 6.9165 16.1268 6.90773 16.191 6.89053C16.5459 6.79535 16.7328 6.47962 16.6445 6.18966Z",
                                        fill: "#1E2432"
                                    })
                                }),
                                "Stores"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: (getAllState === null || getAllState === void 0 ? void 0 : (ref1 = getAllState.lastModalData) === null || ref1 === void 0 ? void 0 : ref1.modal) === "peopleModal" ? "active-sidebar-option" : "",
                            onClick: function() {
                                dispatch((0,manageModalSlice/* fetchModalData */.w)({
                                    allModalData: (0,_to_consumable_array/* default */.Z)(getAllState === null || getAllState === void 0 ? void 0 : getAllState.allModalData).concat([
                                        {
                                            modal: "peopleModal",
                                            isOpen: true,
                                            id: 0,
                                            modalFor: "bigModal"
                                        }, 
                                    ]),
                                    lastModalData: getAllState === null || getAllState === void 0 ? void 0 : getAllState.lastModalData
                                }));
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            clipPath: "url(#clip0_1579_37989)",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M7.91667 8.33333C9.5275 8.33333 10.8333 7.0275 10.8333 5.41667C10.8333 3.80584 9.5275 2.5 7.91667 2.5C6.30583 2.5 5 3.80584 5 5.41667C5 7.0275 6.30583 8.33333 7.91667 8.33333Z",
                                                    stroke: "#1E2432",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M13.5864 2.9165C14.4334 3.42688 14.9999 4.35555 14.9999 5.4165C14.9999 6.47746 14.4334 7.40613 13.5864 7.9165",
                                                    stroke: "#1E2432",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M1.66675 16.9998V17.4998H14.1668V16.9998C14.1668 15.133 14.1668 14.1996 13.8035 13.4865C13.4839 12.8593 12.9739 12.3494 12.3467 12.0298C11.6337 11.6665 10.7003 11.6665 8.83342 11.6665H7.00008C5.13325 11.6665 4.19983 11.6665 3.48678 12.0298C2.85957 12.3494 2.34964 12.8593 2.03006 13.4865C1.66675 14.1996 1.66675 15.133 1.66675 16.9998Z",
                                                    stroke: "#1E2432",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M18.3332 17.4998V16.9998C18.3332 15.133 18.3332 14.1996 17.9699 13.4865C17.6504 12.8593 17.1404 12.3494 16.5132 12.0298",
                                                    stroke: "#1E2432",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                id: "clip0_1579_37989",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                    width: "20",
                                                    height: "20",
                                                    fill: "white"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                "People"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: (getAllState === null || getAllState === void 0 ? void 0 : (ref2 = getAllState.lastModalData) === null || ref2 === void 0 ? void 0 : ref2.modal) === "clubModal" ? "active-sidebar-option" : "",
                            onClick: function() {
                                dispatch((0,manageModalSlice/* fetchModalData */.w)({
                                    allModalData: (0,_to_consumable_array/* default */.Z)(getAllState === null || getAllState === void 0 ? void 0 : getAllState.allModalData).concat([
                                        {
                                            modal: "clubModal",
                                            isOpen: true,
                                            id: 0,
                                            modalFor: "bigModal"
                                        }, 
                                    ]),
                                    lastModalData: getAllState === null || getAllState === void 0 ? void 0 : getAllState.lastModalData
                                }));
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                                            id: "path-1-inside-1_1579_37999",
                                            fill: "white",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M9.99992 5.8335C8.61921 5.8335 7.49992 4.71421 7.49992 3.3335C7.49992 1.95278 8.61921 0.833496 9.99992 0.833496C11.3806 0.833496 12.4999 1.95278 12.4999 3.3335C12.4999 4.71421 11.3806 5.8335 9.99992 5.8335ZM9.16659 5.8335H10.8333C12.214 5.8335 13.3333 6.95278 13.3333 8.3335V9.16683C13.3333 10.5475 12.214 11.6668 10.8333 11.6668H9.16659C7.78587 11.6668 6.66659 10.5475 6.66659 9.16683V8.3335C6.66659 6.95278 7.78587 5.8335 9.16659 5.8335ZM15.8333 13.3335C14.4525 13.3335 13.3333 12.2142 13.3333 10.8335C13.3333 9.45278 14.4525 8.3335 15.8333 8.3335C17.214 8.3335 18.3333 9.45278 18.3333 10.8335C18.3333 12.2142 17.214 13.3335 15.8333 13.3335ZM14.9999 13.3335H16.6666C18.0473 13.3335 19.1666 14.4528 19.1666 15.8335V16.6668C19.1666 18.0475 18.0473 19.1668 16.6666 19.1668H14.9999C13.6192 19.1668 12.4999 18.0475 12.4999 16.6668V15.8335C12.4999 14.4528 13.6192 13.3335 14.9999 13.3335ZM4.16659 13.3335C2.78587 13.3335 1.66659 12.2142 1.66659 10.8335C1.66659 9.45278 2.78587 8.3335 4.16659 8.3335C5.5473 8.3335 6.66659 9.45278 6.66659 10.8335C6.66659 12.2142 5.5473 13.3335 4.16659 13.3335ZM3.33325 13.3335H4.99992C6.38063 13.3335 7.49992 14.4528 7.49992 15.8335V16.6668C7.49992 18.0475 6.38063 19.1668 4.99992 19.1668H3.33325C1.95254 19.1668 0.833252 18.0475 0.833252 16.6668V15.8335C0.833252 14.4528 1.95254 13.3335 3.33325 13.3335Z"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M9.99992 4.3335C9.44763 4.3335 8.99992 3.88578 8.99992 3.3335H5.99992C5.99992 5.54263 7.79078 7.3335 9.99992 7.3335V4.3335ZM8.99992 3.3335C8.99992 2.78121 9.44763 2.3335 9.99992 2.3335V-0.666504C7.79078 -0.666504 5.99992 1.12436 5.99992 3.3335H8.99992ZM9.99992 2.3335C10.5522 2.3335 10.9999 2.78121 10.9999 3.3335H13.9999C13.9999 1.12436 12.2091 -0.666504 9.99992 -0.666504V2.3335ZM10.9999 3.3335C10.9999 3.88578 10.5522 4.3335 9.99992 4.3335V7.3335C12.2091 7.3335 13.9999 5.54263 13.9999 3.3335H10.9999ZM9.16659 7.3335H10.8333V4.3335H9.16659V7.3335ZM10.8333 7.3335C11.3855 7.3335 11.8333 7.78121 11.8333 8.3335H14.8333C14.8333 6.12436 13.0424 4.3335 10.8333 4.3335V7.3335ZM11.8333 8.3335V9.16683H14.8333V8.3335H11.8333ZM11.8333 9.16683C11.8333 9.71911 11.3855 10.1668 10.8333 10.1668V13.1668C13.0424 13.1668 14.8333 11.376 14.8333 9.16683H11.8333ZM10.8333 10.1668H9.16659V13.1668H10.8333V10.1668ZM9.16659 10.1668C8.6143 10.1668 8.16659 9.71911 8.16659 9.16683H5.16659C5.16659 11.376 6.95745 13.1668 9.16659 13.1668V10.1668ZM8.16659 9.16683V8.3335H5.16659V9.16683H8.16659ZM8.16659 8.3335C8.16659 7.78121 8.6143 7.3335 9.16659 7.3335V4.3335C6.95745 4.3335 5.16659 6.12436 5.16659 8.3335H8.16659ZM15.8333 11.8335C15.281 11.8335 14.8333 11.3858 14.8333 10.8335H11.8333C11.8333 13.0426 13.6241 14.8335 15.8333 14.8335V11.8335ZM14.8333 10.8335C14.8333 10.2812 15.281 9.8335 15.8333 9.8335V6.8335C13.6241 6.8335 11.8333 8.62436 11.8333 10.8335H14.8333ZM15.8333 9.8335C16.3855 9.8335 16.8333 10.2812 16.8333 10.8335H19.8333C19.8333 8.62436 18.0424 6.8335 15.8333 6.8335V9.8335ZM16.8333 10.8335C16.8333 11.3858 16.3855 11.8335 15.8333 11.8335V14.8335C18.0424 14.8335 19.8333 13.0426 19.8333 10.8335H16.8333ZM14.9999 14.8335H16.6666V11.8335H14.9999V14.8335ZM16.6666 14.8335C17.2189 14.8335 17.6666 15.2812 17.6666 15.8335H20.6666C20.6666 13.6244 18.8757 11.8335 16.6666 11.8335V14.8335ZM17.6666 15.8335V16.6668H20.6666V15.8335H17.6666ZM17.6666 16.6668C17.6666 17.2191 17.2189 17.6668 16.6666 17.6668V20.6668C18.8757 20.6668 20.6666 18.876 20.6666 16.6668H17.6666ZM16.6666 17.6668H14.9999V20.6668H16.6666V17.6668ZM14.9999 17.6668C14.4476 17.6668 13.9999 17.2191 13.9999 16.6668H10.9999C10.9999 18.876 12.7908 20.6668 14.9999 20.6668V17.6668ZM13.9999 16.6668V15.8335H10.9999V16.6668H13.9999ZM13.9999 15.8335C13.9999 15.2812 14.4476 14.8335 14.9999 14.8335V11.8335C12.7908 11.8335 10.9999 13.6244 10.9999 15.8335H13.9999ZM4.16659 11.8335C3.6143 11.8335 3.16659 11.3858 3.16659 10.8335H0.166585C0.166585 13.0426 1.95745 14.8335 4.16659 14.8335V11.8335ZM3.16659 10.8335C3.16659 10.2812 3.6143 9.8335 4.16659 9.8335V6.8335C1.95745 6.8335 0.166585 8.62436 0.166585 10.8335H3.16659ZM4.16659 9.8335C4.71887 9.8335 5.16659 10.2812 5.16659 10.8335H8.16659C8.16659 8.62436 6.37572 6.8335 4.16659 6.8335V9.8335ZM5.16659 10.8335C5.16659 11.3858 4.71887 11.8335 4.16659 11.8335V14.8335C6.37572 14.8335 8.16659 13.0426 8.16659 10.8335H5.16659ZM3.33325 14.8335H4.99992V11.8335H3.33325V14.8335ZM4.99992 14.8335C5.5522 14.8335 5.99992 15.2812 5.99992 15.8335H8.99992C8.99992 13.6244 7.20906 11.8335 4.99992 11.8335V14.8335ZM5.99992 15.8335V16.6668H8.99992V15.8335H5.99992ZM5.99992 16.6668C5.99992 17.2191 5.5522 17.6668 4.99992 17.6668V20.6668C7.20906 20.6668 8.99992 18.876 8.99992 16.6668H5.99992ZM4.99992 17.6668H3.33325V20.6668H4.99992V17.6668ZM3.33325 17.6668C2.78097 17.6668 2.33325 17.2191 2.33325 16.6668H-0.666748C-0.666748 18.876 1.12411 20.6668 3.33325 20.6668V17.6668ZM2.33325 16.6668V15.8335H-0.666748V16.6668H2.33325ZM2.33325 15.8335C2.33325 15.2812 2.78097 14.8335 3.33325 14.8335V11.8335C1.12411 11.8335 -0.666748 13.6244 -0.666748 15.8335H2.33325Z",
                                            fill: "#1E2432",
                                            mask: "url(#path-1-inside-1_1579_37999)"
                                        })
                                    ]
                                }),
                                "Clubs"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "feed-new-invite-your-friend-alignment",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InviteYourFriends, {
                    setIsModalVisible: setIsModalVisible
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewFooter, {})
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./src/graphql/mutations/joinGroup.ts
var joinGroup = __webpack_require__(9031);
// EXTERNAL MODULE: ./src/graphql/queries/sellerQueries/getJoinedGroups.ts
var getJoinedGroups = __webpack_require__(85357);
// EXTERNAL MODULE: ./src/graphql/queries/queries.ts
var queries = __webpack_require__(40018);
// EXTERNAL MODULE: ./src/utils/LazyImage.tsx
var LazyImage = __webpack_require__(81631);
// EXTERNAL MODULE: ./src/store/slices/fetchAllClubsSlice.tsx + 1 modules
var fetchAllClubsSlice = __webpack_require__(15438);
;// CONCATENATED MODULE: ./src/components/Feed/NewSuggestedClubs/index.tsx


















function NewSuggestedClubs() {
    var dispatch = (0,store/* useAppDispatch */.T)();
    var user = (0,auth/* useAuth */.a)().user;
    var getAllState = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageModalData) === null || ref === void 0 ? void 0 : ref.data;
    });
    var allClubPost = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.clubData) === null || ref === void 0 ? void 0 : ref.allPost;
    });
    (0,react.useEffect)(function() {
        dispatch((0,fetchAllClubsSlice/* fetchAllClubSliceData */.w2)({
            page: 1,
            limit: 2,
            type: "SUGGESTED_CLUBS",
            prevPost: []
        }));
    }, []);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(joinGroup/* default */.Z, {
        onCompleted: function(res) {},
        onError: function(err) {}
    }), 1), joingroup = ref[0];
    var joingroupCall = function(club) {
        if (user) {
            joingroup({
                variables: {
                    group_id: club === null || club === void 0 ? void 0 : club.id,
                    user_id: user === null || user === void 0 ? void 0 : user.id,
                    isAdmin: false
                },
                update: function(proxy, param) {
                    var data = param.data;
                    var ref;
                    var suggestedGroup = proxy.readQuery({
                        query: getJoinedGroups/* default */.Z,
                        variables: {
                            page: 1,
                            limit: 10,
                            search: ""
                        }
                    });
                    proxy.writeQuery({
                        query: getJoinedGroups/* default */.Z,
                        data: {
                            getJoinedGroups: (0,_to_consumable_array/* default */.Z)(suggestedGroup === null || suggestedGroup === void 0 ? void 0 : suggestedGroup.getJoinedGroups).concat([
                                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, club), {
                                    isFollow: true,
                                    members: [
                                        {
                                            firstName: user === null || user === void 0 ? void 0 : user.firstName,
                                            lastName: user === null || user === void 0 ? void 0 : user.lastName,
                                            id: user === null || user === void 0 ? void 0 : user.id,
                                            profileUrl: user === null || user === void 0 ? void 0 : user.logo_image
                                        }, 
                                    ].concat((0,_to_consumable_array/* default */.Z)(club === null || club === void 0 ? void 0 : club.members))
                                }), 
                            ])
                        }
                    });
                    var joinedGroup = proxy.readQuery({
                        query: queries/* GET_GROUPS */.IP
                    });
                    var updatedData = joinedGroup === null || joinedGroup === void 0 ? void 0 : (ref = joinedGroup.groups) === null || ref === void 0 ? void 0 : ref.filter(function(grp) {
                        return (grp === null || grp === void 0 ? void 0 : grp.id) !== (club === null || club === void 0 ? void 0 : club.id);
                    });
                    proxy.writeQuery({
                        query: queries/* GET_GROUPS */.IP,
                        data: {
                            groups: updatedData
                        }
                    });
                }
            });
            dispatch((0,fetchAllClubsSlice/* fetchAllClubSliceData */.w2)({}));
        } else {
            handleRedirect();
        }
    };
    var handleFollow = function(club) {
        if (user) {
            joingroupCall(club);
        } else {
            handleRedirect();
        }
    };
    var handleRedirect = function() {
        dispatch((0,guestAccountDetailSlice/* guestAccountDetailSlice */.Y)({
            modal: "authModal",
            isOpen: true,
            id: {
                media: "https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4",
                modalFor: "login",
                startWith: "loginModal"
            }
        }));
    };
    var handleClubOpen = function(clubId) {
        dispatch((0,manageModalSlice/* fetchModalData */.w)({
            allModalData: (0,_to_consumable_array/* default */.Z)(getAllState === null || getAllState === void 0 ? void 0 : getAllState.allModalData).concat([
                {
                    modal: "group",
                    isOpen: true,
                    id: clubId,
                    modalFor: "bigModal"
                }, 
            ]),
            lastModalData: getAllState === null || getAllState === void 0 ? void 0 : getAllState.lastModalData
        }));
    };
    var handelImageSlider = function() {};
    return Boolean(allClubPost === null || allClubPost === void 0 ? void 0 : allClubPost.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "feed-new-suggested-clubs-alignment",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "feed-new-suggested-clubs-box",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "feed-new-suggested-clubs-heading",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            children: "Suggested Clubs"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: function() {
                                dispatch((0,manageModalSlice/* fetchModalData */.w)({
                                    allModalData: (0,_to_consumable_array/* default */.Z)(getAllState === null || getAllState === void 0 ? void 0 : getAllState.allModalData).concat([
                                        {
                                            modal: "clubModal",
                                            isOpen: true,
                                            id: 0,
                                            modalFor: "bigModal"
                                        }, 
                                    ]),
                                    lastModalData: getAllState === null || getAllState === void 0 ? void 0 : getAllState.lastModalData
                                }));
                            },
                            children: "See More"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "feed-new-suggested-clubs-body-details-alignment",
                    children: allClubPost === null || allClubPost === void 0 ? void 0 : allClubPost.map(function(group, i) {
                        var ref, ref1, ref2, ref3, ref4;
                        return i < 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "feed-new-suggested-details-box-alignment",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "feed-new-suggested-club-img",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.Z, {
                                        image: {
                                            src: group === null || group === void 0 ? void 0 : group.banner_image,
                                            alt: "Icon"
                                        },
                                        objectFit: "cover",
                                        handleClickOnImage: function() {
                                            return handelImageSlider();
                                        },
                                        className: "club-image-section"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "feed-new-suggested-club-details-alignment",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "feed-new-suggested-heading",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/club/".concat(group === null || group === void 0 ? void 0 : group.slug),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: group === null || group === void 0 ? void 0 : group.name
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "feed-new-suggested-club-member-details",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "feed-new-suggested-club-member-profile-alignment",
                                                    onClick: handleRedirect,
                                                    children: (ref = group === null || group === void 0 ? void 0 : group.members.slice(0, 3)) === null || ref === void 0 ? void 0 : ref.map(function(member, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "club-img-details",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: (member === null || member === void 0 ? void 0 : member.id) === (user === null || user === void 0 ? void 0 : user.id) && (user === null || user === void 0 ? void 0 : user.logo_image) ? user === null || user === void 0 ? void 0 : user.logo_image : member === null || member === void 0 ? void 0 : member.logo_image,
                                                                alt: "club img "
                                                            })
                                                        }, index);
                                                    })
                                                }),
                                                (group === null || group === void 0 ? void 0 : (ref1 = group.members) === null || ref1 === void 0 ? void 0 : ref1.length) > 3 && (group === null || group === void 0 ? void 0 : group.total_members) - ((ref2 = group === null || group === void 0 ? void 0 : group.members.slice(0, 3)) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "total-club-member-box",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            "+",
                                                            (group === null || group === void 0 ? void 0 : group.total_members) - ((ref3 = group === null || group === void 0 ? void 0 : group.members.slice(0, 3)) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 ? (group === null || group === void 0 ? void 0 : group.total_members) - ((ref4 = group === null || group === void 0 ? void 0 : group.members.slice(0, 3)) === null || ref4 === void 0 ? void 0 : ref4.length) : ""
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        (group === null || group === void 0 ? void 0 : group.isExist) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "feed-new-suggested-unfollow-details",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: "Joined"
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "join-club-memeber-button-alignment",
                                            onClick: function() {
                                                return handleFollow(group);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                children: "+ Join Club"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, i);
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/graphql/mutations/followStore.ts
var mutations_followStore = __webpack_require__(28387);
// EXTERNAL MODULE: ./src/graphql/mutations/unFollowStore.ts
var unFollowStore = __webpack_require__(98932);
// EXTERNAL MODULE: ./node_modules/antd/es/notification/index.js + 1 modules
var notification = __webpack_require__(13448);
// EXTERNAL MODULE: ./src/store/slices/fetchAllStoresSlice.tsx
var fetchAllStoresSlice = __webpack_require__(29494);
;// CONCATENATED MODULE: ./src/components/Feed/NewSuggestedStores/index.tsx

















function NewSuggestedStores() {
    var dispatch = (0,store/* useAppDispatch */.T)();
    var user = (0,auth/* useAuth */.a)().user;
    var ref = (0,react.useState)(1), page = ref[0], setPage = ref[1];
    var ref1 = (0,react.useState)(2), limit = ref1[0], setLimit = ref1[1];
    var getAllState = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageModalData) === null || ref === void 0 ? void 0 : ref.data;
    });
    var allPopularStores = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.storesData) === null || ref === void 0 ? void 0 : ref.allPopularStores;
    });
    // const { loading, error, data, refetch } = useQuery(GET_ALL_STORE, {
    //   variables: {
    //     limit: 2,
    //     page: 1,
    //     type: "ALL_STORE"
    //   },
    // })
    // useEffect(() => {
    //   refetch()
    // }, [])
    (0,react.useEffect)(function() {
        dispatch((0,fetchAllStoresSlice/* fetchPopularStoreData */.iG)({
            limit: limit,
            page: page,
            type: "ALL_STORE",
            search: ""
        }));
    }, []);
    var handleOpenStoreModal = function(store) {
        dispatch((0,manageModalSlice/* fetchModalData */.w)({
            allModalData: (0,_to_consumable_array/* default */.Z)(getAllState === null || getAllState === void 0 ? void 0 : getAllState.allModalData).concat([
                {
                    modal: "store",
                    isOpen: true,
                    id: {
                        store: {
                            name: store === null || store === void 0 ? void 0 : store.name,
                            id: store === null || store === void 0 ? void 0 : store.id,
                            slug: store === null || store === void 0 ? void 0 : store.slug
                        }
                    },
                    modalFor: "bigModal",
                    startDate: moment_default()().toISOString()
                }, 
            ]),
            lastModalData: getAllState === null || getAllState === void 0 ? void 0 : getAllState.lastModalData
        }));
    };
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations_followStore/* default */.Z, {
        onCompleted: function(res) {
            dispatch((0,fetchAllStoresSlice/* fetchPopularStoreData */.iG)({
                limit: limit,
                page: page,
                type: "ALL_STORE",
                search: ""
            }));
        },
        onError: function(err) {}
    }), 1), followStore = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(unFollowStore/* default */.Z, {
        onCompleted: function(res) {
            setTimeout(function() {
                dispatch((0,fetchAllStoresSlice/* fetchPopularStoreData */.iG)({
                    limit: limit,
                    page: page,
                    type: "ALL_STORE",
                    search: ""
                }));
            }, 500);
        },
        onError: function(err) {
            notification/* default.error */.Z.error({
                message: "Error",
                description: "Something went wrong"
            });
        }
    }), 1), unfollowStore = ref3[0];
    var handleFollow = function(st) {
        if (user) {
            followStore({
                variables: {
                    store_id: st.id
                }
            });
        } else {
            handleRedirect();
        }
    };
    var handleRedirect = function() {
        dispatch((0,guestAccountDetailSlice/* guestAccountDetailSlice */.Y)({
            modal: "authModal",
            isOpen: true,
            id: {
                media: "https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4",
                modalFor: "login",
                startWith: "loginModal"
            }
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "feed-new-suggested-details-alignment",
            children: allPopularStores && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "feed-new-suggested-box-alignment",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "feed-new-suggested-box-heading",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                children: "Suggested Stores"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                onClick: function() {
                                    dispatch((0,manageModalSlice/* fetchModalData */.w)({
                                        allModalData: (0,_to_consumable_array/* default */.Z)(getAllState === null || getAllState === void 0 ? void 0 : getAllState.allModalData).concat([
                                            {
                                                modal: "storesModal",
                                                isOpen: true,
                                                id: 0,
                                                modalFor: "mediumModal"
                                            }, 
                                        ]),
                                        lastModalData: getAllState === null || getAllState === void 0 ? void 0 : getAllState.lastModalData
                                    }));
                                },
                                children: "See More"
                            })
                        ]
                    }),
                    allPopularStores === null || allPopularStores === void 0 ? void 0 : allPopularStores.map(function(store, i) {
                        return i < 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "feed-new-suggested-body-details-alignment",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "feed-new-suggested-child-box-alignment",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "feed-new-suggested-img-alignment",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.Z, {
                                            image: {
                                                src: store === null || store === void 0 ? void 0 : store.logo_image,
                                                alt: "Icon"
                                            },
                                            className: "new-suggested-img-alignment-img",
                                            objectFit: "contain"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "feed-new-suggested-profile-details",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/store/".concat(store === null || store === void 0 ? void 0 : store.slug),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: store === null || store === void 0 ? void 0 : store.name
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "feed-new-suggested-flex-alignment",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            (store === null || store === void 0 ? void 0 : store.followers_count) || 0,
                                                            " followers"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            (store === null || store === void 0 ? void 0 : store.product_count) || 0,
                                                            " products"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            (store === null || store === void 0 ? void 0 : store.isFollow) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "feed-new-suggested-unfollow-details",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            width: "13",
                                                            height: "10",
                                                            viewBox: "0 0 13 10",
                                                            fill: "none",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M1 4.5L5 8.5L12 1",
                                                                stroke: "#7A7E88",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: "Followed"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "feed-new-suggested-follow-details",
                                                onClick: function() {
                                                    return handleFollow(store);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: "+ Follow Store"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, i);
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./src/store/slices/fetchAllFeedSlice.tsx + 2 modules
var fetchAllFeedSlice = __webpack_require__(64089);
// EXTERNAL MODULE: ./src/components/Feed/SendInvitation/SendInvitation.module.scss
var SendInvitation_module = __webpack_require__(88793);
var SendInvitation_module_default = /*#__PURE__*/__webpack_require__.n(SendInvitation_module);
// EXTERNAL MODULE: ./src/components/Feed/SendinvitationbyEmail/SendinvitationEmail.module.scss
var SendinvitationEmail_module = __webpack_require__(4015);
var SendinvitationEmail_module_default = /*#__PURE__*/__webpack_require__.n(SendinvitationEmail_module);
// EXTERNAL MODULE: ./src/graphql/mutations/sendInvitation.ts
var mutations_sendInvitation = __webpack_require__(14244);
;// CONCATENATED MODULE: ./src/components/Feed/SendinvitationbyEmail/index.tsx








function SendInvitationEmail(param) {
    var isOpen = param.isOpen, onClose = param.onClose, transformedContacts = param.transformedContacts, setIsModalVisible = param.setIsModalVisible;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)([]), isChecked = ref[0], setIsChecked = ref[1];
    var ref1 = (0,react.useState)(""), searchQuery = ref1[0], setSearchQuery = ref1[1];
    var ref2 = (0,react.useState)([]), selectedEmails = ref2[0], setSelectedEmails = ref2[1];
    (0,react.useEffect)(function() {
        if (transformedContacts.length > 0) {
            setIsChecked(Array(transformedContacts.length).fill(false));
        }
    }, [
        transformedContacts
    ]);
    var handleCheckboxToggle = function(index) {
        var ref, ref1, ref2;
        var updatedChecked = (0,_to_consumable_array/* default */.Z)(isChecked);
        updatedChecked[index] = !updatedChecked[index];
        setIsChecked(updatedChecked);
        var email = (ref = transformedContacts[index]) === null || ref === void 0 ? void 0 : (ref1 = ref.emailAddresses) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.value;
        if (email) {
            setSelectedEmails(function(prev) {
                if (updatedChecked[index]) {
                    return prev.includes(email) ? prev : (0,_to_consumable_array/* default */.Z)(prev).concat([
                        email
                    ] // Add only if not already included
                    );
                } else {
                    return prev.filter(function(e) {
                        return e !== email;
                    }) // Remove if unchecked
                    ;
                }
            });
        }
    };
    var handleSelectAllToggle = function() {
        var allChecked = isChecked.every(function(checked) {
            return checked;
        });
        var newCheckedState = Array(transformedContacts.length).fill(!allChecked);
        setIsChecked(newCheckedState);
        if (!allChecked) {
            var allEmails = transformedContacts.filter(function(item) {
                var ref, ref1;
                return item === null || item === void 0 ? void 0 : (ref = item.emailAddresses) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.value;
            }).map(function(item) {
                return item.emailAddresses[0].value;
            });
            setSelectedEmails(allEmails);
        } else {
            setSelectedEmails([]) // Clear selection on "Uncheck All"
            ;
        }
    };
    var handleSearchChange = function(e) {
        setSearchQuery(e.target.value.toLowerCase());
    };
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations_sendInvitation/* default */.Z, {
        onCompleted: function(param) {
            var sendInvitation = param.sendInvitation;
            onClose();
            setIsModalVisible(false);
        },
        onError: function(error) {}
    }), 1), sendInvitation = ref3[0];
    var handleSendInvitation = function() {
        sendInvitation({
            variables: {
                emails: selectedEmails
            }
        });
    };
    // Filtered contacts based on search query
    var filteredContacts = transformedContacts.filter(function(item) {
        var ref, ref1, ref2, ref3;
        var email = (item === null || item === void 0 ? void 0 : (ref = item.emailAddresses) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.value) || "";
        var phone = (item === null || item === void 0 ? void 0 : (ref2 = item.phoneNumbers) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.canonicalForm) || "";
        return email.toLowerCase().includes(searchQuery) || phone.includes(searchQuery);
    });
    if (!isOpen) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (SendinvitationEmail_module_default()).SendInvitationEmailmain,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (SendinvitationEmail_module_default()).sendInvitationEmailModalBox,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SendinvitationEmail_module_default()).SendinvitationEmailModalHeding,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: "Invite Friends to Bluejestic"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SendinvitationEmail_module_default()).SendininvitationEmailheadingCLose,
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M18 6L6 18",
                                        stroke: "#7A7E88",
                                        strokeWidth: "1.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M6 6L18 18",
                                        stroke: "#7A7E88",
                                        strokeWidth: "1.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SendinvitationEmail_module_default()).SendinvitationEmailModelbody,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SendinvitationEmail_module_default()).SendinvitationEmailModeltitle,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Invite friends using your Gmail address book"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (SendinvitationEmail_module_default()).SendInvitationEmailmodelSearchbar,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "search",
                                            placeholder: "Search",
                                            value: searchQuery,
                                            onChange: handleSearchChange
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (SendinvitationEmail_module_default()).SendInvitationEmailmodelSearcicon,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "40",
                                                height: "40",
                                                viewBox: "0 0 40 40",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M19 27C23.4183 27 27 23.4183 27 19C27 14.5817 23.4183 11 19 11C14.5817 11 11 14.5817 11 19C11 23.4183 14.5817 27 19 27Z",
                                                        stroke: "#ACB1C0",
                                                        strokeWidth: "1.5",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M28.9999 29L24.6499 24.65",
                                                        stroke: "#ACB1C0",
                                                        strokeWidth: "1.5",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SendinvitationEmail_module_default()).SendinvitationEmailModelSelectedfriendnumbers,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    isChecked.filter(function(checked) {
                                        return checked;
                                    }).length,
                                    " friends selected"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SendinvitationEmail_module_default()).SendinvitationEmailModelSelectfriend,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Check all / Uncheck all"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((SendinvitationEmail_module_default()).SendinvitationEmailModelSelectallfriendcheckbox, " ").concat(isChecked.every(function(checked) {
                                        return checked;
                                    }) ? (SendinvitationEmail_module_default()).SendinvitationEmailModelSelectallfriendcheckboxcheck : ""),
                                    onClick: handleSelectAllToggle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (SendinvitationEmail_module_default()).SendinvitationEmailModelSelectallfriendcheckboxcheckedcircle
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SendinvitationEmail_module_default()).SendinvitationEmailModelSelectedfriendsmainbody,
                            children: filteredContacts === null || filteredContacts === void 0 ? void 0 : filteredContacts.map(function(item, index) {
                                var ref, ref1, ref2;
                                var email = item === null || item === void 0 ? void 0 : (ref = item.emailAddresses) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.value;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: (item === null || item === void 0 ? void 0 : (ref2 = item.emailAddresses) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (SendinvitationEmail_module_default()).SendinvitationEmailModelSelectedfriendsboxm,
                                        onClick: function() {
                                            return handleCheckboxToggle(index);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: email
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((SendinvitationEmail_module_default()).SendinvitationEmailModelSelectallfriendcheckbox, " ").concat(isChecked[index] ? (SendinvitationEmail_module_default()).SendinvitationEmailModelSelectallfriendcheckboxcheck : ""),
                                                onClick: function() {
                                                    return handleCheckboxToggle(index);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (SendinvitationEmail_module_default()).SendinvitationEmailModelSelectallfriendcheckboxcheckedcircle
                                                })
                                            })
                                        ]
                                    })
                                });
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SendinvitationEmail_module_default()).SendininvitationEmailLastbuttonsmain,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    onClick: onClose,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    disabled: !isChecked.some(function(checked) {
                                        return checked;
                                    }),
                                    onClick: function() {
                                        return handleSendInvitation();
                                    },
                                    children: "Send Invitations"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@react-oauth/google/dist/index.esm.js
var index_esm = __webpack_require__(86426);
// EXTERNAL MODULE: ./node_modules/react-share/dist/index.js
var dist = __webpack_require__(68258);
;// CONCATENATED MODULE: ./src/components/Feed/SendInvitation/index.tsx









var SCOPES = "https://www.googleapis.com/auth/contacts.readonly https://www.googleapis.com/auth/userinfo.email";
function SendInvitation(param) {
    var setIsModalVisible = param.setIsModalVisible;
    var ref;
    var ref1 = (0,react.useState)(false), isModalOpen = ref1[0], setIsModalOpen = ref1[1];
    var ref2 = (0,react.useState)([]), contacts = ref2[0], setContacts = ref2[1];
    // Facbook post share Feature
    (0,react.useEffect)(function() {
        (function(d, s, id) {
            var ref;
            var fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            var js = d.createElement(s)// Cast to HTMLScriptElement
            ;
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            (ref = fjs.parentNode) === null || ref === void 0 ? void 0 : ref.insertBefore(js, fjs) // Added optional chaining for safety
            ;
        })(document, "script", "facebook-jssdk");
        // Initialize Facebook SDK after it loads
        window.fbAsyncInit = function() {
            window.FB.init({
                appId: "346654831753825",
                cookie: true,
                xfbml: true,
                version: "v12.0"
            });
            window.FB.AppEvents.logPageView();
        };
    }, []);
    var shareOnFacebook = function() {
        // Ensure FB is initialized
        if (window.FB) {
            window.FB.ui({
                method: "share",
                href: "https://bluejestic.com/",
                picture: "https://bluejestic.com/assets/img/favicons/icon.png"
            }, function(response) {});
        } else {}
    };
    // Gmail Login Feature
    var openModal = function() {
        login();
        setIsModalOpen(true);
    };
    var closeModal = function() {
        setIsModalOpen(false);
    };
    var login = (0,index_esm/* useGoogleLogin */.Nq)({
        scope: SCOPES,
        onSuccess: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(response) {
                var accessToken;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    accessToken = response.access_token;
                    fetchContacts(accessToken);
                    return [
                        2
                    ];
                });
            });
            return function(response) {
                return _ref.apply(this, arguments);
            };
        }(),
        onError: function(error) {}
    });
    var fetchContacts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(accessToken) {
            var res, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetch("https://people.googleapis.com/v1/people/me/connections?personFields=names,emailAddresses,phoneNumbers&access_token=".concat(accessToken))
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            4,
                            res.json()
                        ];
                    case 2:
                        data = _state.sent();
                        setContacts((data === null || data === void 0 ? void 0 : data.connections) || []);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchContacts(accessToken) {
            return _ref.apply(this, arguments);
        };
    }();
    var transformedContacts = contacts.map(function(item) {
        var ref, ref1, ref2;
        var newItem = {};
        if (((ref = item.emailAddresses) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            newItem.emailAddresses = item.emailAddresses.map(function(email) {
                return {
                    value: email.value
                };
            });
        }
        if (((ref1 = item.names) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
            newItem.names = item.names.map(function(name) {
                return {
                    displayName: name.displayName
                };
            });
        }
        if (((ref2 = item.phoneNumbers) === null || ref2 === void 0 ? void 0 : ref2.length) > 0) {
            newItem.phoneNumbers = item.phoneNumbers.map(function(phone) {
                return {
                    canonicalForm: phone.canonicalForm
                };
            });
        }
        return newItem;
    }).filter(function(item) {
        return item.emailAddresses !== undefined;
    });
    // Whatsapp Login Feature
    var projectLink = "https://bluejestic.com/";
    var message = "I want you to join me on MeWe, the Next-Gen Social Network. No Ads. No Spyware. No BS: ".concat(projectLink);
    var openWhatsAppWeb = function() {
        var whatsappUrl = "https://web.whatsapp.com/send?text=".concat(encodeURIComponent(message));
        var mobileWhatsAppUrl = "https://api.whatsapp.com/send?text=".concat(encodeURIComponent(message));
        var isWebAvailable = navigator.userAgent.includes("WebKit");
        if (isWebAvailable) {
            window.open(whatsappUrl, "_blank");
        } else {
            window.open(mobileWhatsAppUrl, "_blank");
        }
    };
    // Pinterest Login Feature
    var url = "https://bluejestic.com/";
    var image = "".concat(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.origin, "/assets/img/pinterestmobile-logo-new.svg");
    var description = "Pinterest";
    var shareToPinterest = function() {
        var pinterestUrl = "https://www.pinterest.com/pin/create/button/?url=".concat(encodeURIComponent(url), "&media=").concat(encodeURIComponent(image), "&description=").concat(encodeURIComponent(description));
        window.open(pinterestUrl, "Pinterest Share", "width=600,height=600,top=100,left=100,toolbar=no,menubar=no,scrollbars=yes,resizable=yes");
    };
    // Share Code
    var handleShare = function(type) {};
    // Copy Link
    var handleCopyClick = function(text) {
        navigator === null || navigator === void 0 ? void 0 : navigator.clipboard.writeText(text).then(function() {
            notification/* default.success */.Z.success({
                message: "Copied!"
            });
        }).catch(function(err) {
            console.error("Failed to copy text: ", err);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SendInvitation_module_default()).sendInvitationModalWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SendInvitation_module_default()).sendInvitationModalBox,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SendInvitation_module_default()).invitationModalHeding,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: "Invite Friends to Bluejestic"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (SendInvitation_module_default()).headingCLose,
                                    onClick: function() {
                                        return setIsModalVisible(false);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M18 6L6 18",
                                                stroke: "#7A7E88",
                                                strokeWidth: "1.5",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M6 6L18 18",
                                                stroke: "#7A7E88",
                                                strokeWidth: "1.5",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SendInvitation_module_default()).sendInvitationModalBody,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Share your profile link to invite friend to Bluejestic"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (SendInvitation_module_default()).profileLinkInput,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            children: "Profile Link"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (SendInvitation_module_default()).profileInput,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    placeholder: "http://www.bluejestic.com/profile/marcos"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (SendInvitation_module_default()).copyIcon,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "24",
                                                        height: "24",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M20 9H11C9.89543 9 9 9.89543 9 11V20C9 21.1046 9.89543 22 11 22H20C21.1046 22 22 21.1046 22 20V11C22 9.89543 21.1046 9 20 9Z",
                                                                stroke: "#7A7E88",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M5 15H4C3.46957 15 2.96086 14.7893 2.58579 14.4142C2.21071 14.0391 2 13.5304 2 13V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H13C13.5304 2 14.0391 2.21071 14.4142 2.58579C14.7893 2.96086 15 3.46957 15 4V5",
                                                                stroke: "#7A7E88",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (SendInvitation_module_default()).socialShareOptionDetails,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            children: "Share via social networks"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (SendInvitation_module_default()).socialShareOption,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (SendInvitation_module_default()).optionBox,
                                                    onClick: shareOnFacebook,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "36",
                                                        height: "36",
                                                        viewBox: "0 0 36 36",
                                                        fill: "none",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M33.0001 17.9981C33.0001 9.71386 26.2843 2.99805 18.0001 2.99805C9.71581 2.99805 3 9.71374 3 17.9981C3 25.485 8.48534 31.6907 15.6563 32.816V22.3341H11.8477V17.9981H15.6563V14.6934C15.6563 10.934 17.8958 8.85745 21.322 8.85745C22.9632 8.85745 24.6798 9.15042 24.6798 9.15042V12.8418H22.7884C20.9248 12.8418 20.3438 13.9981 20.3438 15.1844V17.9981H24.504L23.839 22.3341H20.3438V32.816C27.5148 31.6907 33.0001 25.4851 33.0001 17.9981Z",
                                                                fill: "#1877F2"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M23.8389 22.334L24.504 17.9981H20.3438V15.1844C20.3438 13.998 20.9249 12.8418 22.7883 12.8418H24.6797V9.15039C24.6797 9.15039 22.9632 8.85742 21.322 8.85742C17.8957 8.85742 15.6563 10.934 15.6563 14.6934V17.9981H11.8477V22.334H15.6563V32.8159C16.4316 32.9374 17.2152 32.9984 18 32.9981C18.7848 32.9984 19.5685 32.9375 20.3438 32.8159V22.334H23.8389Z",
                                                                fill: "white"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (SendInvitation_module_default()).optionBox,
                                                    onClick: openWhatsAppWeb,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "36",
                                                        height: "36",
                                                        viewBox: "0 0 36 36",
                                                        fill: "none",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M28.5753 7.36365C27.2001 5.97453 25.5621 4.87314 23.7568 4.12371C21.9514 3.37428 20.015 2.99181 18.0603 2.99862C9.87023 2.99862 3.1952 9.67366 3.1952 17.8637C3.1952 20.4887 3.8852 23.0387 5.17521 25.2888L3.0752 32.9988L10.9502 30.9288C13.1253 32.1138 15.5703 32.7438 18.0603 32.7438C26.2503 32.7438 32.9254 26.0688 32.9254 17.8787C32.9254 13.9037 31.3804 10.1687 28.5753 7.36365ZM18.0603 30.2238C15.8403 30.2238 13.6653 29.6238 11.7602 28.4988L11.3102 28.2288L6.63022 29.4588L7.87522 24.8988L7.57522 24.4338C6.34183 22.4642 5.68692 20.1876 5.68521 17.8637C5.68521 11.0537 11.2352 5.50364 18.0453 5.50364C21.3453 5.50364 24.4503 6.79365 26.7753 9.13366C27.9266 10.2796 28.8389 11.6427 29.4594 13.1438C30.08 14.645 30.3964 16.2544 30.3904 17.8787C30.4204 24.6887 24.8703 30.2238 18.0603 30.2238ZM24.8403 20.9837C24.4653 20.8037 22.6353 19.9037 22.3053 19.7687C21.9603 19.6487 21.7203 19.5887 21.4653 19.9487C21.2103 20.3237 20.5053 21.1637 20.2953 21.4037C20.0853 21.6587 19.8603 21.6887 19.4853 21.4937C19.1103 21.3137 17.9103 20.9087 16.5003 19.6487C15.3903 18.6587 14.6553 17.4437 14.4303 17.0687C14.2203 16.6937 14.4003 16.4987 14.5953 16.3037C14.7603 16.1387 14.9703 15.8687 15.1503 15.6587C15.3303 15.4487 15.4053 15.2837 15.5253 15.0437C15.6453 14.7887 15.5853 14.5787 15.4953 14.3987C15.4053 14.2187 14.6553 12.3887 14.3553 11.6387C14.0553 10.9187 13.7403 11.0087 13.5153 10.9937H12.7953C12.5402 10.9937 12.1502 11.0837 11.8052 11.4587C11.4752 11.8337 10.5152 12.7337 10.5152 14.5637C10.5152 16.3937 11.8502 18.1637 12.0302 18.4037C12.2102 18.6587 14.6553 22.4087 18.3753 24.0137C19.2603 24.4037 19.9503 24.6287 20.4903 24.7938C21.3753 25.0788 22.1853 25.0338 22.8303 24.9438C23.5503 24.8387 25.0353 24.0437 25.3353 23.1737C25.6503 22.3037 25.6503 21.5687 25.5453 21.4037C25.4403 21.2387 25.2153 21.1637 24.8403 20.9837Z",
                                                            fill: "#65D072"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (SendInvitation_module_default()).optionBox,
                                                    onClick: shareToPinterest,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "36",
                                                        height: "36",
                                                        viewBox: "0 0 36 36",
                                                        fill: "none",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M13.5601 32.3087C15.0001 32.7437 16.4551 32.9987 18.0001 32.9987C21.9784 32.9987 25.7937 31.4184 28.6068 28.6053C31.4198 25.7922 33.0002 21.9769 33.0002 17.9986C33.0002 16.0288 32.6122 14.0782 31.8584 12.2583C31.1045 10.4384 29.9996 8.78485 28.6068 7.39196C27.2139 5.99907 25.5603 4.89417 23.7404 4.14035C21.9205 3.38652 19.9699 2.99854 18.0001 2.99854C16.0302 2.99854 14.0797 3.38652 12.2598 4.14035C10.4399 4.89417 8.78631 5.99907 7.39342 7.39196C4.58036 10.205 3 14.0204 3 17.9986C3 24.3737 7.00502 29.8487 12.6601 32.0087C12.5251 30.8387 12.3901 28.9037 12.6601 27.5687L14.3851 20.1586C14.3851 20.1586 13.9501 19.2886 13.9501 17.9086C13.9501 15.8386 15.2401 14.2936 16.7101 14.2936C18.0001 14.2936 18.6001 15.2386 18.6001 16.4536C18.6001 17.7436 17.7451 19.5886 17.3101 21.3586C17.0551 22.8287 18.0901 24.1187 19.5901 24.1187C22.2601 24.1187 24.3301 21.2686 24.3301 17.2486C24.3301 13.6486 21.7501 11.1886 18.0451 11.1886C13.8151 11.1886 11.325 14.3386 11.325 17.6536C11.325 18.9436 11.7451 20.2486 12.4351 21.1036C12.5701 21.1936 12.5701 21.3136 12.5251 21.5386L12.0901 23.1737C12.0901 23.4287 11.9251 23.5187 11.6701 23.3387C9.75004 22.4986 8.64003 19.7686 8.64003 17.5636C8.64003 12.8236 12.0001 8.51857 18.4801 8.51857C23.6401 8.51857 27.6601 12.2236 27.6601 17.1436C27.6601 22.3036 24.4651 26.4437 19.8901 26.4437C18.4351 26.4437 17.0101 25.6637 16.5001 24.7487L15.4951 28.3037C15.1501 29.5937 14.2051 31.3187 13.5601 32.3537V32.3087Z",
                                                            fill: "#D32D2F"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (SendInvitation_module_default()).optionBox,
                                                    onClick: function() {
                                                        return handleShare("twitter");
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* TwitterShareButton */.B, {
                                                        url: "".concat("https://bluejestic.com"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            width: "30",
                                                            height: "30",
                                                            viewBox: "0 0 30 30",
                                                            fill: "none",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M21.901 4.50049H25.581L17.541 13.3969L27 25.5005H19.594L13.794 18.1588L7.156 25.5005H3.474L12.074 15.9845L3 4.50146H10.594L15.837 11.212L21.901 4.50049ZM20.61 23.3688H22.649L9.486 6.52082H7.298L20.61 23.3688Z",
                                                                fill: "#101419"
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (SendInvitation_module_default()).optionBox,
                                                    onClick: function() {
                                                        return handleCopyClick("".concat("https://bluejestic.com"));
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "24",
                                                        height: "24",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M10 13.0028C10.4294 13.577 10.9774 14.052 11.6065 14.3958C12.2357 14.7395 12.9315 14.9439 13.6466 14.9952C14.3618 15.0464 15.0796 14.9432 15.7513 14.6926C16.4231 14.442 17.0331 14.0499 17.54 13.5428L20.5399 10.5428C21.4507 9.59984 21.9547 8.33684 21.9433 7.02586C21.9319 5.71488 21.4061 4.46083 20.479 3.53379C19.552 2.60676 18.2979 2.08092 16.987 2.06952C15.676 2.05813 14.413 2.5621 13.47 3.47289L11.75 5.18288",
                                                                stroke: "#1E2432",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M14.0001 11.0022C13.5707 10.428 13.0228 9.95299 12.3936 9.60923C11.7644 9.26548 11.0686 9.06106 10.3535 9.00984C9.63836 8.95863 8.92057 9.06181 8.24882 9.31239C7.57706 9.56298 6.96706 9.9551 6.46017 10.4622L3.46019 13.4622C2.54941 14.4052 2.04544 15.6682 2.05683 16.9791C2.06822 18.2901 2.59406 19.5442 3.5211 20.4712C4.44813 21.3982 5.70219 21.9241 7.01316 21.9355C8.32414 21.9469 9.58714 21.4429 10.5301 20.5321L12.2401 18.8221",
                                                                stroke: "#1E2432",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (SendInvitation_module_default()).socialShareOptionDetails,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            children: "Upload your address book to invite friends"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (SendInvitation_module_default()).socialShareOption,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (SendInvitation_module_default()).optionBox,
                                                onClick: openModal,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/icon/gmail-icon.svg",
                                                    alt: "gmail icon"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (SendInvitation_module_default()).inviteFriendAlignment,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (SendInvitation_module_default()).inviteFriendLabel,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                children: "Invite Friend by E-mail"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (SendInvitation_module_default()).inviteFriendInput,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (SendInvitation_module_default()).inviteFriendGrid,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (SendInvitation_module_default()).inviteFriendEmailInput,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "text",
                                                            placeholder: "Enter address"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (SendInvitation_module_default()).inviteButton,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                width: "24",
                                                                height: "24",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M12 5V19",
                                                                        stroke: "#556EE6",
                                                                        strokeWidth: "1.5",
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M5 12H19",
                                                                        stroke: "#556EE6",
                                                                        strokeWidth: "1.5",
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (SendInvitation_module_default()).inviteFriendSendButton,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        children: "Send"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SendInvitationEmail, {
                isOpen: isModalOpen,
                onClose: closeModal,
                transformedContacts: transformedContacts,
                setIsModalVisible: setIsModalVisible
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/shared/Common/HeaderWelcomline/HeaderWelcomeline.module.scss
var HeaderWelcomeline_module = __webpack_require__(65638);
var HeaderWelcomeline_module_default = /*#__PURE__*/__webpack_require__.n(HeaderWelcomeline_module);
;// CONCATENATED MODULE: ./src/components/shared/Common/HeaderWelcomline/HeaderWelcomeline.tsx



function HeaderWelcomeline() {
    var marqueeRef = (0,react.useRef)(null);
    var containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if ((marqueeRef === null || marqueeRef === void 0 ? void 0 : marqueeRef.current) && (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current)) {
            var ref, ref1, ref2;
            var marqueeWidth = marqueeRef === null || marqueeRef === void 0 ? void 0 : (ref = marqueeRef.current) === null || ref === void 0 ? void 0 : ref.offsetWidth;
            containerRef === null || containerRef === void 0 ? void 0 : (ref1 = containerRef.current) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.style) === null || ref2 === void 0 ? void 0 : ref2.setProperty("--marquee-width", "".concat(marqueeWidth, "px"));
            var animationDuration = 60;
            var pauseDuration = 5;
            var animate = function() {
                var ref, ref1, ref2, ref3;
                containerRef === null || containerRef === void 0 ? void 0 : (ref = containerRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.remove((HeaderWelcomeline_module_default()).paused);
                containerRef === null || containerRef === void 0 ? void 0 : (ref2 = containerRef.current) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.classList) === null || ref3 === void 0 ? void 0 : ref3.add((HeaderWelcomeline_module_default()).animated);
                setTimeout(function() {
                    var ref, ref1, ref2, ref3;
                    containerRef === null || containerRef === void 0 ? void 0 : (ref = containerRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.remove((HeaderWelcomeline_module_default()).animated);
                    containerRef === null || containerRef === void 0 ? void 0 : (ref2 = containerRef.current) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.classList) === null || ref3 === void 0 ? void 0 : ref3.add((HeaderWelcomeline_module_default()).paused);
                    setTimeout(animate, pauseDuration * 1000);
                }, animationDuration * 1000);
            };
            animate();
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (HeaderWelcomeline_module_default()).headerWelcomeline,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (HeaderWelcomeline_module_default()).marqueeContainer,
            ref: containerRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HeaderWelcomeline_module_default()).marquee,
                ref: marqueeRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "Welcome to Bluejestic Beta v1.0! \uD83D\uDE80 We're excited to have you on this journey with us. If you encounter any bugs or issues, please",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://formbricks.internal.bluejestic.com/s/cm2e88bmt002nzu796xr0hjrd",
                            target: "_blank",
                            children: "click here"
                        }),
                        " ",
                        "to report them. Your feedback is key to helping us build one of the best social shopping platforms out there! \uD83D\uDE4C"
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./src/graphql/mutations/deleteLike.ts
var mutations_deleteLike = __webpack_require__(58720);
// EXTERNAL MODULE: ./src/graphql/mutations/createLike.ts
var mutations_createLike = __webpack_require__(46771);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./public/assets/icon/blue-shopping-bag.svg
var blue_shopping_bag = __webpack_require__(42331);
// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var nookies_dist = __webpack_require__(62286);
var dist_default = /*#__PURE__*/__webpack_require__.n(nookies_dist);
// EXTERNAL MODULE: ./public/assets/icon/white-more-icon.svg
var white_more_icon = __webpack_require__(59256);
// EXTERNAL MODULE: ./src/store/slices/mobileModalSlice.tsx
var mobileModalSlice = __webpack_require__(64965);
// EXTERNAL MODULE: ./src/store/slices/productShareOptionsSlice.tsx
var productShareOptionsSlice = __webpack_require__(34710);
// EXTERNAL MODULE: ./src/graphql/mutations/removeBookmark.ts
var mutations_removeBookmark = __webpack_require__(43214);
// EXTERNAL MODULE: ./src/graphql/queries/getAllBookmark.ts
var getAllBookmark = __webpack_require__(26574);
// EXTERNAL MODULE: ./src/store/slices/manageAddProductDetail.tsx
var manageAddProductDetail = __webpack_require__(53757);
// EXTERNAL MODULE: ./src/utils/LazyProductImage.tsx
var LazyProductImage = __webpack_require__(64399);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/store/slices/manageBookmarkTab.tsx
var manageBookmarkTab = __webpack_require__(31735);
// EXTERNAL MODULE: ./src/graphql/mutations/removeProductFromCollection.ts
var removeProductFromCollection = __webpack_require__(29558);
// EXTERNAL MODULE: ./src/graphql/mutations/createCart.ts
var mutations_createCart = __webpack_require__(10551);
// EXTERNAL MODULE: ./src/store/slices/getCartCount.tsx + 2 modules
var getCartCount = __webpack_require__(59921);
;// CONCATENATED MODULE: ./src/components/ProductPage/AllProduct/Productv2/index.tsx
































function Productv2(props) {
    var handleClose = function handleClose() {
        setOpenDropdown(false);
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    var user = (0,auth/* useAuth */.a)().user;
    var router = (0,next_router.useRouter)();
    var product = props.product, storeData = props.storeData, isInCollection = props.isInCollection, isShowToast = props.isShowToast, isForPost = props.isForPost, isRemoveProduct = props.isRemoveProduct, className = props.className, dataLimite = props.dataLimite, page = props.page, setPage = props.setPage, bookMark = props.bookMark, APIcall = props.APIcall;
    var allStores = (0,es/* useSelector */.v9)(function(state) {
        return state === null || state === void 0 ? void 0 : state.storesData;
    });
    var productRef = (0,react.useRef)();
    var dispatch = (0,store/* useAppDispatch */.T)();
    var getAllState = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageModalData) === null || ref === void 0 ? void 0 : ref.data;
    });
    var fetchMobileModal = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageMobileModal) === null || ref === void 0 ? void 0 : ref.data;
    });
    var bookmarkTabData = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageBookmarkTabsSlice) === null || ref === void 0 ? void 0 : ref.data;
    });
    var ref24 = (0,react.useState)(0), indexImage = ref24[0], setIndexImage = ref24[1];
    var ref25 = (0,react.useState)({}), selectedProduct = ref25[0], setSelectedProduct = ref25[1];
    var ref26 = (0,react.useState)(false), openDropdown = ref26[0], setOpenDropdown = ref26[1];
    var ref27 = (0,react.useState)(false), isCalling = ref27[0], setIsCalling = ref27[1];
    var ref28 = (0,react.useState)(0), isDesktop = ref28[0], setIsDesktop = ref28[1];
    var ref29 = (0,react.useState)(false), isLiked = ref29[0], setIsLiked = ref29[1];
    var ref30 = (0,react.useState)(false), isBookmark = ref30[0], setIsBookmark = ref30[1];
    // const [productRecommendationsFetched, setProductRecommendationsFetched] = useState(false)
    var handleResize = function() {
        return setIsDesktop(window.innerWidth);
    };
    (0,react.useEffect)(function() {
        setIsDesktop(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    (0,react.useEffect)(function() {
        var liked = localStorage.getItem("liked_".concat(product === null || product === void 0 ? void 0 : product.id));
        var bookmarked = localStorage.getItem("bookmarked_".concat(product === null || product === void 0 ? void 0 : product.id));
        if (liked) setIsLiked(JSON.parse(liked));
        if (bookmarked) setIsBookmark(JSON.parse(bookmarked));
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    // useEffect(() => {
    //   const isRefresh = !performance
    //     .getEntriesByType('navigation')
    //     .some((entry) => (entry as PerformanceNavigationTiming).type === 'navigate')
    //   if (isRefresh) {
    //     router.replace(
    //       {
    //         pathname: router.pathname,
    //         query: {},
    //       },
    //       undefined,
    //       { shallow: true },
    //     )
    //     window.scrollTo(0, 0)
    //   } else {
    //     const productId = localStorage.getItem('productId')
    //     const page = localStorage.getItem('page')
    //     if (page) {
    //       // setPage(Number(page))
    //       if (productId) {
    //         const element = document.getElementById(productId)
    //         if (element) {
    //           element.scrollIntoView({ behavior: 'smooth' })
    //           localStorage.removeItem('productId')
    //           localStorage.removeItem('page')
    //         }
    //       }
    //     }
    //     // const cookies = nookies.get(undefined)
    //     // const productId = cookies.productId
    //     // const { page: nookiesPage } = nookies.get()
    //     // if (nookiesPage) {
    //     //   // setPage(Number(nookiesPage))
    //     //   if (productId) {
    //     //     const element = document.getElementById(productId)
    //     //     if (element) {
    //     //       element.scrollIntoView({ behavior: 'smooth' })
    //     //       nookies.destroy(undefined, 'productId', { path: '/' })
    //     //       nookies.destroy(undefined, 'page', { path: '/' })
    //     //     }
    //     //   }
    //     // }
    //   }
    //   const handleBeforeUnload = () => {
    //     nookies.destroy(undefined, 'productId', { path: '/' })
    //   }
    //   window.addEventListener('beforeunload', handleBeforeUnload)
    //   return () => {
    //     window.removeEventListener('beforeunload', handleBeforeUnload)
    //   }
    // }, [router])
    var arrow = /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 36 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "18",
                cy: "17",
                rx: "18",
                ry: "17",
                fill: "black",
                fillOpacity: "0.4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.0336 11.0395L15.0677 17.0735L21.1017 23.0393L19.113 25.0506L11.0678 17.0962L19.0222 9.0509L21.0336 11.0395Z",
                fill: "#E4E4E8"
            })
        ]
    });
    var stopMovie = function(e) {
        e.target.pause();
    };
    var playMovie = function(e) {
        e.target.play();
    };
    var changeIndexImage = function(temp) {
        var ref, ref1;
        var index = indexImage + temp;
        if (index >= (product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : ref.length)) index = 0;
        else if (index < 0) index = (product === null || product === void 0 ? void 0 : (ref1 = product.images) === null || ref1 === void 0 ? void 0 : ref1.length) - 1;
        setIndexImage(index);
    };
    var handleSaveData = function(prod) {
        if (user) {
            setSelectedProduct(prod);
            setOpenDropdown(true);
        } else {
            handleRedirect();
        }
    };
    var handleOpenProduct = function(product) {
        if (product === null || product === void 0 ? void 0 : product.slug) {
            dist_default().set(undefined, "productId", product.id, {
                path: "/"
            });
            dist_default().set(undefined, "page", page, {
                path: "/"
            });
            router.push("/product/".concat(product === null || product === void 0 ? void 0 : product.slug));
        }
        dispatch((0,manageAddProductDetail/* manageAddProductDetail */.D)({
            modal: "",
            isOpen: false,
            id: {
                selectedCategories: [],
                selectedColorArray: [],
                selectedColor: "",
                selectedText: "",
                variant: {
                    isAddVariantModal: false,
                    isAddColorModalOpen: false,
                    isAddOtherVariantModalOpen: false,
                    dataEdit: {},
                    allVariant: [],
                    colorCodeArray: [],
                    allFinalVariant: [],
                    variantError: {},
                    isVariantModel: false,
                    colorStates: []
                },
                isEditableData: {
                    index: null,
                    data: null
                },
                productPreview: {
                    title: "",
                    image: "",
                    price: "",
                    listPrice: ""
                },
                mobileProductsData: [],
                filteredList: [],
                filterColorList: [],
                newVariantDataState: [],
                productDetails: {
                    productDetailVariant: {},
                    productSelectedOption: {},
                    productDetailColor: ""
                }
            }
        }));
    };
    // const [addBookmark] = useMutation(ADD_BOOKMARK, {
    //   onCompleted: (res) => {
    //     dispatch(fetchAllBookmarkProducts({ page: 1, limit: 10 }))
    //     dispatch(
    //       fetchProductByCategory({
    //         category: 'Fashion & Accessories',
    //         subCategory: 'Women',
    //         childSubCategory: router?.query?.category ? router?.query?.category : '',
    //         isShopifyProduct: false,
    //       }),
    //     )
    //   },
    //   onError: (error) => {
    //     console.log(error)
    //   },
    // })
    var ref31 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations_removeBookmark/* default */.Z, {
        onCompleted: function(res) {
            dispatch((0,fetchAllStoresSlice/* fetchAllBookmarkProducts */.GO)({
                page: 1,
                limit: 10
            }));
        },
        onError: function(error) {
            console.log(error);
        }
    }), 1), removeBookmark = ref31[0];
    var handleAddToCollection = function(product) {
        if (user) {
            var ref;
            dispatch((0,manageBookmarkTab/* manageBookmark */.m)({
                modal: "",
                isOpen: false,
                id: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bookmarkTabData === null || bookmarkTabData === void 0 ? void 0 : bookmarkTabData.id), {
                    addProductToCollection: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bookmarkTabData === null || bookmarkTabData === void 0 ? void 0 : (ref = bookmarkTabData.id) === null || ref === void 0 ? void 0 : ref.deleteCollection), {
                        isShowAddCollectionModel: true,
                        // collectionId: getAllState?.lastModalData?.item?.id,
                        productId: product === null || product === void 0 ? void 0 : product.id
                    })
                })
            }));
        } else {
            handleRedirect();
        }
    };
    var ref32 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations_createCart/* default */.Z, {
        onCompleted: function(res) {
            dispatch((0,getCartCount/* getAllCartCountSliceData */.NO)());
        },
        onError: function(error) {
            notification/* default.error */.Z.error({
                message: "Error",
                description: "Sorry, you can only purchase allowable quantity of this product"
            });
        }
    }), 1), createCart = ref32[0];
    var QuantityHandler = function() {
        if (user) {
            createCart({
                variables: {
                    input: {
                        parent_id: product === null || product === void 0 ? void 0 : product.id,
                        quantity: 1,
                        cart_for: "PRODUCT"
                    }
                }
            });
        } else {
            handleRedirect();
        }
    };
    var addBookmarkFromFeed = function(product) {
        if (user && !isBookmark) {
            var ref, ref1, ref2, ref3;
            dispatch((0,manageBookmarkTab/* manageBookmark */.m)({
                modal: "",
                isOpen: true,
                id: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bookmarkTabData === null || bookmarkTabData === void 0 ? void 0 : bookmarkTabData.id), {
                    type: "feed",
                    bookmark_id: product === null || product === void 0 ? void 0 : (ref = product.bookmark) === null || ref === void 0 ? void 0 : ref.id,
                    product_id: product === null || product === void 0 ? void 0 : product.id,
                    collection_id: product === null || product === void 0 ? void 0 : (ref1 = product.bookmark) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.collection) === null || ref2 === void 0 ? void 0 : ref2.id,
                    addProductToCollection: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bookmarkTabData === null || bookmarkTabData === void 0 ? void 0 : (ref3 = bookmarkTabData.id) === null || ref3 === void 0 ? void 0 : ref3.deleteCollection), {
                        isShowAddCollectionModel: true,
                        productId: product === null || product === void 0 ? void 0 : product.id
                    })
                })
            }));
            setIsBookmark(true);
            localStorage.setItem("bookmarked_".concat(product === null || product === void 0 ? void 0 : product.id), JSON.stringify(true));
        } else {
            handleRedirect();
        }
    };
    var handleRemoveBookmark = function(product) {
        var ref, ref1, ref2, ref3;
        removeProductFromBookmark({
            variables: {
                collectionId: product === null || product === void 0 ? void 0 : (ref = product.bookmark) === null || ref === void 0 ? void 0 : (ref1 = ref.collection) === null || ref1 === void 0 ? void 0 : ref1.id,
                productId: product === null || product === void 0 ? void 0 : product.id,
                isRemoveFromCollectionOnly: true
            },
            refetchQueries: [
                {
                    query: getAllBookmark/* default */.Z,
                    variables: {
                        slug: product === null || product === void 0 ? void 0 : (ref2 = product.bookmark) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.collection) === null || ref3 === void 0 ? void 0 : ref3.id,
                        page: 1,
                        limit: 10
                    }
                }, 
            ]
        });
    };
    var ref33 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(removeProductFromCollection/* default */.Z, {
        onCompleted: function(res) {},
        onError: function(error) {
            console.log(error);
        }
    }), 1), removeProductFromBookmark = ref33[0];
    var handleRedirect = function() {
        dispatch((0,guestAccountDetailSlice/* guestAccountDetailSlice */.Y)({
            modal: "authModal",
            isOpen: true,
            id: {
                media: "https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4",
                modalFor: "login",
                startWith: "loginModal"
            }
        }));
    };
    var handleOpenShareFriend = function() {
        dispatch((0,productShareOptionsSlice/* fetchProductShareOptions */.u)({
            modal: "productShareWithFriend",
            isOpen: true,
            id: 0
        }));
    };
    var shareFeedOnGroup = function() {
        dispatch((0,productShareOptionsSlice/* fetchProductShareOptions */.u)({
            modal: "productSharewithClub",
            isOpen: true,
            // id: { ...data, groupId: 0, selectedProduct: selectedProduct, isGroupPost: true },
            id: {
                groupId: 0,
                selectedProduct: selectedProduct,
                isGroupPost: true
            }
        }));
    };
    var shareOnfeed = function() {
        dispatch((0,productShareOptionsSlice/* fetchProductShareOptions */.u)({
            modal: "productShareOnMyFeedModal",
            isOpen: true,
            id: {
                selectedProduct: selectedProduct,
                isGroupPost: false
            }
        }));
    };
    var handelImageSlider = function() {};
    var ref34 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations_createLike/* default */.Z, {
        onCompleted: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(response, param) {
                var product_id, ref;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    product_id = param.context.product_id;
                    if (response === null || response === void 0 ? void 0 : (ref = response.likes) === null || ref === void 0 ? void 0 : ref.id) {
                        APIcall(product_id, "like");
                    }
                    return [
                        2
                    ];
                });
            });
            return function(response, _) {
                return _ref.apply(this, arguments);
            };
        }(),
        onError: function(error) {
            console.log(error);
        }
    }), 1), createLike = ref34[0];
    var ref35 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations_deleteLike/* default */.Z, {
        onCompleted: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(response, param) {
                var product_id, ref;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    product_id = param.context.product_id;
                    if (response === null || response === void 0 ? void 0 : (ref = response.likes) === null || ref === void 0 ? void 0 : ref.id) {
                        APIcall(product_id, "dislike");
                    }
                    return [
                        2
                    ];
                });
            });
            return function(response, _) {
                return _ref.apply(this, arguments);
            };
        }(),
        onError: function(error) {
            console.log(error);
        }
    }), 1), deleteLike = ref35[0];
    var likeProduct = function(product) {
        if (user && !isLiked) {
            var likeFor = "PRODUCT";
            createLike({
                variables: {
                    parent_id: product === null || product === void 0 ? void 0 : product.id,
                    like_for: likeFor
                },
                context: {
                    product_id: product === null || product === void 0 ? void 0 : product.id
                }
            });
            setIsLiked(true);
            localStorage.setItem("liked_".concat(product === null || product === void 0 ? void 0 : product.id), JSON.stringify(true));
        } else {
            handleRedirect();
        }
    };
    var handleAddBookmark = function() {
        var ref, ref1, ref2, ref3;
        dispatch((0,manageBookmarkTab/* manageBookmark */.m)({
            modal: "",
            isOpen: true,
            id: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bookmarkTabData === null || bookmarkTabData === void 0 ? void 0 : bookmarkTabData.id), {
                // post: post,
                type: "product",
                bookmark_id: product === null || product === void 0 ? void 0 : (ref = product.bookmark) === null || ref === void 0 ? void 0 : ref.id,
                product_id: product === null || product === void 0 ? void 0 : product.id,
                collection_id: product === null || product === void 0 ? void 0 : (ref1 = product.bookmark) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.collection) === null || ref2 === void 0 ? void 0 : ref2.id,
                addProductToCollection: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bookmarkTabData === null || bookmarkTabData === void 0 ? void 0 : (ref3 = bookmarkTabData.id) === null || ref3 === void 0 ? void 0 : ref3.deleteCollection), {
                    isShowAddCollectionModel: true,
                    productId: product === null || product === void 0 ? void 0 : product.id
                })
            })
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: product === null || product === void 0 ? void 0 : product.id,
        className: "product-container-main hide-product-details-show  ".concat(className),
        onMouseEnter: handleClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "image-contain ".concat(isForPost ? "imageSliderHeightAlignment" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "image-contain-dataimage-contain-data",
                        onClick: function() {
                            return handleOpenProduct(product);
                        },
                        children: [
                            (product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : ref.length) > 0 && ((ref1 = product === null || product === void 0 ? void 0 : product.images[indexImage]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.src) === null || ref2 === void 0 ? void 0 : ref2.includes("mp4")) || (product === null || product === void 0 ? void 0 : (ref3 = product.images) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 && ((ref4 = product === null || product === void 0 ? void 0 : product.images[indexImage]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.src) === null || ref5 === void 0 ? void 0 : ref5.includes("mov")) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                loop: true,
                                autoPlay: true,
                                onMouseOver: playMovie,
                                onMouseOut: stopMovie,
                                poster: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: (product === null || product === void 0 ? void 0 : (ref6 = product.images) === null || ref6 === void 0 ? void 0 : ref6.length) > 0 && ((ref7 = product === null || product === void 0 ? void 0 : product.images[indexImage]) === null || ref7 === void 0 ? void 0 : ref7.src),
                                    type: "video/mp4"
                                })
                            }) : // <img src={'https://cdn.shopify.com/s/files/1/0842/0704/2859/files/front_8afd0e53-f4ab-40cd-a777-153c6af111a7.jpg?v=1702676692'} />
                            // <div
                            //   className="poroduct-image-background"
                            //   style={{
                            //     backgroundImage:
                            //       'url(https://cdn.shopify.com/s/files/1/0842/0704/2859/files/front_8afd0e53-f4ab-40cd-a777-153c6af111a7.jpg?v=1702676692)',
                            //     // background : "red"
                            //   }}
                            // ></div>
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyProductImage/* default */.Z, {
                                image: {
                                    src: (product === null || product === void 0 ? void 0 : (ref8 = product.images) === null || ref8 === void 0 ? void 0 : ref8.length) > 0 && ((ref9 = product === null || product === void 0 ? void 0 : product.images[indexImage]) === null || ref9 === void 0 ? void 0 : ref9.src),
                                    alt: "Icon"
                                },
                                objectFit: "cover",
                                // width={308}
                                height: isDesktop > 1024 ? 308 : 140,
                                handleClickOnImage: function() {
                                    return handelImageSlider();
                                },
                                className: "product-main-image-section"
                            }),
                            isShowToast && ((product === null || product === void 0 ? void 0 : (ref10 = product.bookmark) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.collection) === null || ref11 === void 0 ? void 0 : ref11.name) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mobile-view-on-summary-section",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: product === null || product === void 0 ? void 0 : (ref12 = product.bookmark) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.collection) === null || ref13 === void 0 ? void 0 : ref13.name
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mobile-view-add-product-bookmark-section",
                                onClick: function(e) {
                                    e.stopPropagation();
                                    dispatch((0,mobileModalSlice/* fetchMobileModalData */.B)({
                                        allModalData: (0,_to_consumable_array/* default */.Z)((fetchMobileModal === null || fetchMobileModal === void 0 ? void 0 : fetchMobileModal.allModalData) ? fetchMobileModal === null || fetchMobileModal === void 0 ? void 0 : fetchMobileModal.allModalData : []).concat([
                                            {
                                                modal: "mobileViewAddProductModal",
                                                isOpen: true,
                                                id: product === null || product === void 0 ? void 0 : product.id,
                                                transform: 440
                                            }, 
                                        ]),
                                        lastModalData: (fetchMobileModal === null || fetchMobileModal === void 0 ? void 0 : fetchMobileModal.lastModalData) ? fetchMobileModal === null || fetchMobileModal === void 0 ? void 0 : fetchMobileModal.lastModalData : []
                                    }));
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 16 16",
                                        fill: "none",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M3.33301 8L12.6663 8",
                                                stroke: "white",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M8 3.33301L12.6667 7.99967L8 12.6663",
                                                stroke: "white",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 16 16",
                                        fill: "none",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                clipPath: "url(#clip0_1210_23765)",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M7.38514 2.31989L9.86214 2.0096C10.5461 1.92391 11.1685 2.42159 11.2523 3.1212M3.64466 13.0745C2.96066 13.1602 2.33825 12.6625 2.25447 11.9629L2.02694 10.0628L1.79941 8.16265L1.57188 6.26252L1.34434 4.36239C1.26057 3.66279 1.74715 3.02618 2.43115 2.94049",
                                                        stroke: "white",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                        x: "3.9873",
                                                        y: "3.50781",
                                                        width: "10.0298",
                                                        height: "10.0298",
                                                        rx: "0.930002",
                                                        transform: "rotate(3.20951 3.9873 3.50781)",
                                                        fill: "white",
                                                        stroke: "white"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                    id: "clip0_1210_23765",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                        width: "16",
                                                        height: "16",
                                                        fill: "white",
                                                        transform: "translate(0.000976562)"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mobile-view-more-option-alignment",
                                onClick: function(e) {
                                    e.stopPropagation();
                                    dispatch((0,mobileModalSlice/* fetchMobileModalData */.B)({
                                        allModalData: (0,_to_consumable_array/* default */.Z)((fetchMobileModal === null || fetchMobileModal === void 0 ? void 0 : fetchMobileModal.allModalData) ? fetchMobileModal === null || fetchMobileModal === void 0 ? void 0 : fetchMobileModal.allModalData : []).concat([
                                            {
                                                modal: "productOption",
                                                isOpen: true,
                                                id: product,
                                                transform: 508
                                            }, 
                                        ]),
                                        lastModalData: fetchMobileModal === null || fetchMobileModal === void 0 ? void 0 : fetchMobileModal.lastModalData
                                    }));
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: white_more_icon/* default.src */.Z.src,
                                    alt: "WhiteMoreArrow"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "onhover-align",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "image-index-align",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "number-of-index",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                indexImage + 1,
                                                "/",
                                                product === null || product === void 0 ? void 0 : (ref14 = product.images) === null || ref14 === void 0 ? void 0 : ref14.length
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "like-more-alignment",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "like-button-alignment",
                                                onClick: function() {
                                                    return !isLiked && likeProduct(product);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "27",
                                                    height: "27",
                                                    viewBox: "0 0 27 27",
                                                    fill: isLiked ? "#ff0000" : "none",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M9.3877 6.1897C6.61117 6.1897 4.36035 8.44053 4.36035 11.217C4.36035 16.2444 10.3018 20.8147 13.501 21.8778C16.7002 20.8147 22.6416 16.2444 22.6416 11.217C22.6416 8.44053 20.3908 6.1897 17.6143 6.1897C15.914 6.1897 14.4108 7.03379 13.501 8.32577C12.5912 7.03379 11.088 6.1897 9.3877 6.1897Z",
                                                        stroke: "#F8F8F8",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "more-button-alignment",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "option-icon-alignment",
                                                        onClick: function() {
                                                            return handleSaveData(product);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            width: "24",
                                                            height: "24",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                fillRule: "evenodd",
                                                                clipRule: "evenodd",
                                                                d: "M7.5 11C8.32843 11 9 11.6716 9 12.5C9 13.3284 8.32843 14 7.5 14C6.67157 14 6 13.3284 6 12.5C6 11.6716 6.67157 11 7.5 11ZM12.5 11C13.3284 11 14 11.6716 14 12.5C14 13.3284 13.3284 14 12.5 14C11.6716 14 11 13.3284 11 12.5C11 11.6716 11.6716 11 12.5 11ZM19 12.5C19 11.6716 18.3284 11 17.5 11C16.6716 11 16 11.6716 16 12.5C16 13.3284 16.6716 14 17.5 14C18.3284 14 19 13.3284 19 12.5Z",
                                                                fill: "#F8F8F8"
                                                            })
                                                        })
                                                    }),
                                                    openDropdown && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "more-option-dropdown-alignment",
                                                        ref: productRef,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "dropdown-option dropdown-option-first hover:bg-indigo-50 py-3",
                                                                        onClick: function() {
                                                                            return handleAddBookmark();
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "dropdown-main",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "dropdown-icon",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: "/assets/img/store/product/bookmark.svg"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "dropdown-content",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                            children: "Add to Bookmark"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: "Save this product for later"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "dropdown-option py-3",
                                                                        onClick: function() {
                                                                            return shareOnfeed();
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "dropdown-main",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "dropdown-icon",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: "/assets/img/store/product/grid.svg"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "dropdown-content",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                            children: "Share on my feed"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: "Share this post on my feed"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "dropdown-option dropdown-option-last hover:bg-indigo-50 py-3",
                                                                        // onClick={() => setIsShareFriedModalVisible(true)}
                                                                        onClick: function() {
                                                                            return handleOpenShareFriend();
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "dropdown-main",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "dropdown-icon",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: "/assets/img/store/product/share-with-frd.svg"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "dropdown-content",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                            children: "Share with Friends"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: "Share post with friends"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "dropdown-option dropdown-option-last hover:bg-indigo-50 py-3",
                                                                        onClick: function() {
                                                                            return shareFeedOnGroup();
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "dropdown-main",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "dropdown-icon",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: "/assets/img/store/product/share-with-club-frd.svg"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "dropdown-content",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                            children: "Share with Club"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: "Share post with clubs friends"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "hover-info-align",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return changeIndexImage(-1);
                                        },
                                        children: arrow
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return changeIndexImage(1);
                                        },
                                        style: {
                                            transform: "rotate(180deg)"
                                        },
                                        children: arrow
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bottom-section",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-color-main",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "color-alignment",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/img/product/product-color-ellipse.png"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "3"
                                                })
                                            ]
                                        })
                                    }),
                                    isShowToast && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "add-product-collection-alignment",
                                        children: [
                                            !(product === null || product === void 0 ? void 0 : (ref15 = product.bookmark) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.collection) === null || ref16 === void 0 ? void 0 : ref16.name) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "add-production-box",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "collection-icon arrow-left-alignment",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            width: "24",
                                                            height: "24",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M5 12L19 12",
                                                                    stroke: "white",
                                                                    strokeWidth: "1.5",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M12 5L19 12L12 19",
                                                                    stroke: "white",
                                                                    strokeWidth: "1.5",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "collection-icon",
                                                        onClick: function() {
                                                            return handleAddToCollection(product);
                                                        }
                                                    })
                                                ]
                                            }),
                                            isInCollection && user && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "add-production-box",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "collection-icon arrow-left-alignment",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/assets/icon/arrow-right-white.svg",
                                                            alt: "arrow icon"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "collection-icon",
                                                        onClick: function() {
                                                            return handleRemoveBookmark(product);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/assets/icon/collection-icon.svg",
                                                            alt: "collection icon"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isShowToast && (product === null || product === void 0 ? void 0 : (ref17 = product.bookmark) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.collection) === null || ref18 === void 0 ? void 0 : ref18.name) && !isInCollection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mobile-view-on-summary-section",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: product === null || product === void 0 ? void 0 : (ref19 = product.bookmark) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.collection) === null || ref20 === void 0 ? void 0 : ref20.name
                                })
                            })
                        ]
                    })
                ]
            }),
            !isForPost && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid-image-main-handler",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "spacer-image-grid-alignment",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-image-list",
                        children: (ref22 = product === null || product === void 0 ? void 0 : (ref21 = product.images) === null || ref21 === void 0 ? void 0 : ref21.slice(0, 8)) === null || ref22 === void 0 ? void 0 : ref22.map(function(img, index) {
                            var ref, ref1;
                            if ((img === null || img === void 0 ? void 0 : (ref = img.src) === null || ref === void 0 ? void 0 : ref.includes("mp4")) || (img === null || img === void 0 ? void 0 : (ref1 = img.src) === null || ref1 === void 0 ? void 0 : ref1.includes("mov"))) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: indexImage === index ? "media-border active-border" : "media-border",
                                    onClick: function() {
                                        return setIndexImage(index);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                        loop: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                            src: img === null || img === void 0 ? void 0 : img.src,
                                            type: "video/mp4"
                                        })
                                    })
                                }, index);
                            } else {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: indexImage === index ? "media-border active-border" : "media-border",
                                    onClick: function() {
                                        return setIndexImage(index);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.Z, {
                                        image: {
                                            src: img === null || img === void 0 ? void 0 : img.src,
                                            alt: "Icon"
                                        },
                                        objectFit: "cover",
                                        handleClickOnImage: function() {
                                            return handelImageSlider();
                                        },
                                        // imageClassName={'post-media-radious'}
                                        className: "product-sub-image"
                                    })
                                }, index);
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-description-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            onClick: function() {
                                return handleOpenProduct(product);
                            },
                            children: (product === null || product === void 0 ? void 0 : (ref23 = product.title) === null || ref23 === void 0 ? void 0 : ref23.length) > 25 ? (product === null || product === void 0 ? void 0 : product.title.substring(0, 25)) + "..." : product === null || product === void 0 ? void 0 : product.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "price-analytics-section",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "price-data",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: (product === null || product === void 0 ? void 0 : product.dis_price) && "$"
                                        }),
                                        " ",
                                        product === null || product === void 0 ? void 0 : product.dis_price
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "price-analytics-section-price-and-buttons",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                (product === null || product === void 0 ? void 0 : product.dis_listPrice) && "$",
                                                " ",
                                                product === null || product === void 0 ? void 0 : product.dis_listPrice
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "price-analytics-section-buttons-main",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "price-analytics-section-buttons ",
                                                    onClick: function() {
                                                        return !isBookmark && addBookmarkFromFeed(product);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        width: "24",
                                                        height: "24",
                                                        viewBox: "0 0 24 24",
                                                        fill: isBookmark ? "#556EE6" : "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M19 21L12 16L5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21Z",
                                                            stroke: "#556EE6",
                                                            strokeWidth: "1.5",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "price-analytics-section-buttons",
                                                    onClick: function() {
                                                        return QuantityHandler();
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: blue_shopping_bag/* default.src */.Z.src,
                                                        alt: "BlueShoppingIcon"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            isRemoveProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-view-bookmark-remove-product-alignment",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mobile-view-bookmark-remove-icon-alignment",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M19 12L5 12",
                                    stroke: "white",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M12 19L5 12L12 5",
                                    stroke: "white",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M11.0753 3.47984L14.7908 3.01439C15.8168 2.88586 16.7504 3.63239 16.876 4.6818M5.46455 19.6118C4.43855 19.7403 3.50493 18.9938 3.37927 17.9444L3.03797 15.0942L2.69667 12.244L2.35537 9.39378L2.01407 6.54359C1.88841 5.49418 2.61828 4.53927 3.64429 4.41074",
                                    stroke: "white",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    x: "5.97852",
                                    y: "5.26172",
                                    width: "15.0447",
                                    height: "15.0447",
                                    rx: "1.395",
                                    transform: "rotate(3.20951 5.97852 5.26172)",
                                    fill: "white",
                                    stroke: "white",
                                    strokeWidth: "1.5"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Feed/ProductRecommendation/index.tsx
// @ts-nocheck









function ProductRecommendation(param) {
    var productRecommendations = param.productRecommendations;
    var SampleNextArrow = function SampleNextArrow(props) {
        var onClick = props.onClick;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "slick-next-arrow",
            onClick: onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "40",
                height: "40",
                viewBox: "0 0 40 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        opacity: "0.6",
                        cx: "20",
                        cy: "20",
                        r: "20",
                        transform: "rotate(-180 20 20)",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M21 25L17 20L21 15",
                        stroke: "#1E2432",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    })
                ]
            })
        });
    };
    var SamplePrevArrow = function SamplePrevArrow(props) {
        var onClick = props.onClick;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "slick-prev-arrow",
            onClick: onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "40",
                height: "40",
                viewBox: "0 0 40 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        opacity: "0.6",
                        cx: "20",
                        cy: "20",
                        r: "20",
                        transform: "rotate(-180 20 20)",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M21 25L17 20L21 15",
                        stroke: "#1E2432",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    })
                ]
            })
        });
    };
    var bookmarkTabData = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageBookmarkTabsSlice) === null || ref === void 0 ? void 0 : ref.data;
    });
    var dispatch = (0,store/* useAppDispatch */.T)();
    var user = (0,auth/* useAuth */.a)().user;
    var ProductRecommendations = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SampleNextArrow, {}),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SamplePrevArrow, {}),
        //   rtl: false,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }, 
        ]
    };
    // const [removeBookmark] = useMutation(REMOVE_BOOKMARK, {
    //   onCompleted: (res) => {
    //     console.log('ressssss', res)
    //   },
    //   onError: (error) => {
    //     console.log(error)
    //   },
    // })
    // const handleRedirect = () => {
    //   dispatch(
    //     guestAccountDetailSlice({
    //       modal: 'authModal',
    //       isOpen: true,
    //       id: {
    //         media: 'https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4',
    //         modalFor: 'login',
    //         startWith: 'loginModal',
    //       },
    //     }),
    //   )
    // }
    // const addBookmark = (product) => {
    //   console.log('productttttttttt', product)
    //   if (user) {
    //     if (product?.bookmark?.id) {
    //       removeBookmark({
    //         variables: {
    //           id: product?.bookmark?.id,
    //         },
    //       })
    //     } else {
    //       dispatch(
    //         manageBookmark({
    //           modal: '',
    //           isOpen: true,
    //           id: {
    //             ...bookmarkTabData?.id,
    //             // post: post,
    //             type: 'feed',
    //             bookmark_id: product?.bookmark?.id,
    //             product_id: product?.id,
    //             collection_id: product?.bookmark?.collection?.id,
    //             addProductToCollection: {
    //               ...bookmarkTabData?.id?.deleteCollection,
    //               isShowAddCollectionModel: true,
    //               productId: product?.id,
    //             },
    //           },
    //         }),
    //       )
    //     }
    //   } else {
    //     handleRedirect()
    //   }
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "rounded-xl mobile:border-t mobile:border-gray-300 custom-mb-8 feed-post-details-box p-4 recommendation-section-main-box",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    children: "Products Recommendations"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "recommendation-section-main",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "recommendation-section",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ProductRecommendations), {
                            children: productRecommendations === null || productRecommendations === void 0 ? void 0 : productRecommendations.map(function(recommendation, index) {
                                return(// <Product
                                //   product={recommendation}
                                //   showProduct={{}}
                                //   storeData={{}}
                                //   isForPost={true}
                                //   isRecommendation={true}
                                //   // bookMark={addBookmark}
                                // />
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Productv2, {
                                    product: recommendation,
                                    showProduct: {},
                                    storeData: {},
                                    isForPost: true,
                                    isRecommendation: true
                                }));
                            })
                        }))
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Feed/FeedComponent/index.tsx


























var clientId = "274190812220-4qrs07kk5n2j6ap38stpbu1t2icod3b5.apps.googleusercontent.com";
function FeedComponent(props) {
    var handleClose = // useEffect(() => {
    //   if (user && allPost.length % 5 === 0 && allPost.length !== 0) {
    //     dispatch(fetchProductRecommendation('shopping_trend')).then((action) => {
    //       if (action.payload && action.payload.length > 0) {
    //         setProductRecommendations(action.payload)
    //       }
    //     })
    //   }
    // }, [allPost, user])
    function handleClose() {
        setOpenDropdown(false);
    };
    var containerRef = (0,react.useRef)(null);
    var dispatch = (0,store/* useAppDispatch */.T)();
    var ref = (0,react.useState)(1), page = ref[0], setPage = ref[1];
    var ref1 = (0,react.useState)(5), limit = ref1[0], setLimit = ref1[1];
    var ref2 = (0,react.useState)(false), isModalVisible = ref2[0], setIsModalVisible = ref2[1];
    var ref3 = (0,react.useState)(false), openDropdown = ref3[0], setOpenDropdown = ref3[1];
    var ref4 = (0,react.useState)(0), recommendationIndex = ref4[0], setRecommendationIndex = ref4[1];
    var ref5 = (0,react.useState)(false), productRecommendationsFetched = ref5[0], setProductRecommendationsFetched = ref5[1];
    var ref6 = (0,react.useState)({}), recommendationsMap = ref6[0], setRecommendationsMap = ref6[1];
    var allPost = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.feedData) === null || ref === void 0 ? void 0 : ref.allPost;
    });
    var productRecommendations = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.feedData) === null || ref === void 0 ? void 0 : ref.productRecommendations;
    });
    var isallPostEnd = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.feedData) === null || ref === void 0 ? void 0 : ref.isEnd;
    });
    var product = props.product, storeData = props.storeData, isInCollection = props.isInCollection, isShowToast = props.isShowToast, isForPost = props.isForPost, isRemoveProduct = props.isRemoveProduct, className = props.className, dataLimite = props.dataLimite, APIcall = props.APIcall;
    var user = (0,auth/* useAuth */.a)().user;
    (0,react.useEffect)(function() {
        dispatch((0,fetchAllFeedSlice/* fetchAllFeedSliceData */.cn)({
            page: page,
            limit: limit,
            prevPost: page === 1 ? [] : allPost
        }));
    }, []);
    var handleRedirect = function() {
        dispatch((0,guestAccountDetailSlice/* guestAccountDetailSlice */.Y)({
            modal: "authModal",
            isOpen: true,
            id: {
                media: "https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4",
                modalFor: "login",
                startWith: "loginModal"
            }
        }));
    };
    (0,react.useEffect)(function() {
        var container = containerRef.current;
        var handleScroll = function() {
            if (container.scrollHeight - container.scrollTop - container.clientHeight <= 2000 && !isallPostEnd) {
                setPage(page + 1);
                dispatch((0,fetchAllFeedSlice/* fetchAllFeedSliceData */.cn)({
                    page: page + 1,
                    limit: limit,
                    prevPost: allPost
                })).then(function() {
                    if (user && allPost.length % 5 === 0 && allPost.length !== 0) {
                        var recommendationKey = Math.floor(allPost.length / 5);
                        if (!recommendationsMap[recommendationKey]) {
                            dispatch((0,fetchAllFeedSlice/* fetchProductRecommendation */.o_)({
                                type: "shopping_trend",
                                prevRecommendation: []
                            })).then(function(response) {
                                setRecommendationsMap(function(prev) {
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, recommendationKey, response.payload));
                                });
                            });
                        }
                    }
                });
            }
            if (isallPostEnd && container.scrollHeight === container.scrollTop + container.clientHeight) {
                handleRedirect();
            }
        };
        if (container) {
            container.addEventListener("scroll", handleScroll);
            return function() {
                return container.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        containerRef,
        user,
        allPost,
        recommendationsMap
    ]);
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations_createLike/* default */.Z, {
        onCompleted: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(response, param) {
                var product_id, ref;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    product_id = param.context.product_id;
                    if (response === null || response === void 0 ? void 0 : (ref = response.createLike) === null || ref === void 0 ? void 0 : ref.id) {
                        APIcall(product_id, "like");
                    }
                    return [
                        2
                    ];
                });
            });
            return function(response, _) {
                return _ref.apply(this, arguments);
            };
        }(),
        onError: function(error) {
            console.log(error);
        }
    }), 1), createLike = ref7[0];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations_deleteLike/* default */.Z, {
        onCompleted: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(response, param) {
                var product_id, ref, ref1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    product_id = param.context.product_id;
                    if (response === null || response === void 0 ? void 0 : (ref = response.disLike) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.id) {
                        APIcall(product_id, "dislike");
                    }
                    return [
                        2
                    ];
                });
            });
            return function(response, _) {
                return _ref.apply(this, arguments);
            };
        }(),
        onError: function(error) {
            console.log(error);
        }
    }), 1), deleteLike = ref8[0];
    var likeProduct = function(product) {
        if (user) {
            var ref;
            if ((product === null || product === void 0 ? void 0 : (ref = product.likes) === null || ref === void 0 ? void 0 : ref.id) !== 3.3333) {
                var ref1;
                var likeFor = "PRODUCT";
                if (product === null || product === void 0 ? void 0 : (ref1 = product.likes) === null || ref1 === void 0 ? void 0 : ref1.id) {
                    var ref2;
                    deleteLike({
                        variables: {
                            id: product === null || product === void 0 ? void 0 : (ref2 = product.likes) === null || ref2 === void 0 ? void 0 : ref2.id,
                            like_for: likeFor
                        },
                        context: {
                            product_id: product === null || product === void 0 ? void 0 : product.id
                        }
                    });
                    return;
                } else {
                    createLike({
                        variables: {
                            parent_id: product === null || product === void 0 ? void 0 : product.id,
                            like_for: likeFor
                        },
                        context: {
                            product_id: product === null || product === void 0 ? void 0 : product.id
                        }
                    });
                }
            }
        } else {
            handleRedirect();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:bg-white feed-page-alignment",
                ref: containerRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto mobile:hidden tablet:hidden smallTablet:hidden",
                        style: {
                            maxWidth: 1300
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "feed-page-layout-alignment",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "left-sidebar-alignment",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative w-full h-100",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "sticky top-12",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewLeftSidebar, {
                                                setIsModalVisible: setIsModalVisible
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "center-feed-details",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostSomething/* default */.Z, {
                                            title: "Post Something",
                                            mobile: false,
                                            type: "post",
                                            group: {},
                                            isSeller: false
                                        }),
                                        allPost === null || allPost === void 0 ? void 0 : allPost.map(function(post, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NormalPost/* default */.Z, {
                                                        index: i,
                                                        post: post,
                                                        store: {},
                                                        image: true,
                                                        type: "post",
                                                        color: false,
                                                        feedSize: true,
                                                        isUserPostPreviewModal: true
                                                    }),
                                                    (i + 1) % 5 === 4 && recommendationsMap[Math.floor(i / 5)] && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductRecommendation, {
                                                        productRecommendations: recommendationsMap[Math.floor(i / 5)]
                                                    })
                                                ]
                                            }, i);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "right-sidebar-alignment",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative h-100",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "sticky top-12",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "right-side-overflow-alignment",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewSuggestedStores, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewSuggestedClubs, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWelcomeline, {})
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostSomethingMobile/* default */.Z, {
                        title: "Create Post",
                        mobile: true,
                        type: "post",
                        group: {},
                        isSeller: false
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mobile:block tablet:block smallTablet:block lg:hidden mobile-view-height-alignment space-y-2",
                        children: (allPost === null || allPost === void 0 ? void 0 : allPost.length) > 0 ? allPost === null || allPost === void 0 ? void 0 : allPost.map(function(post, i) {
                            var key = Math.floor(Math.random() * 900) + 100;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NormalPost/* default */.Z, {
                                        index: i,
                                        post: post,
                                        store: {},
                                        image: true,
                                        type: "post",
                                        color: false,
                                        feedSize: true,
                                        isUserPostPreviewModal: false
                                    }),
                                    (i + 1) % 5 === 4 && recommendationsMap[Math.floor(i / 5)] && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductRecommendation, {
                                        productRecommendations: recommendationsMap[Math.floor(i / 5)]
                                    }),
                                    " "
                                ]
                            }, i);
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "no-data-box-alignment"
                            })
                        })
                    })
                ]
            }),
            isModalVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GoogleOAuthProvider */.rg, {
                clientId: clientId,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SendInvitation, {
                    setIsModalVisible: setIsModalVisible
                })
            })
        ]
    });
}


/***/ }),

/***/ 88793:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sendInvitationModalWrapper":"SendInvitation_sendInvitationModalWrapper__qVKJV","sendInvitationModalBox":"SendInvitation_sendInvitationModalBox__eCftT","invitationModalHeding":"SendInvitation_invitationModalHeding__R87Os","headingCLose":"SendInvitation_headingCLose__Urasl","sendInvitationModalBody":"SendInvitation_sendInvitationModalBody__zM_Rg","profileLinkInput":"SendInvitation_profileLinkInput__ZU_jp","profileInput":"SendInvitation_profileInput__lE1Mj","copyIcon":"SendInvitation_copyIcon__UG79J","socialShareOptionDetails":"SendInvitation_socialShareOptionDetails__KxOoW","socialShareOption":"SendInvitation_socialShareOption__sceh5","optionBox":"SendInvitation_optionBox__9KKX4","inviteFriendAlignment":"SendInvitation_inviteFriendAlignment__6sbQ_","inviteFriendLabel":"SendInvitation_inviteFriendLabel__wYYsu","inviteFriendInput":"SendInvitation_inviteFriendInput__zjhje","inviteFriendGrid":"SendInvitation_inviteFriendGrid__YYrcG","inviteFriendEmailInput":"SendInvitation_inviteFriendEmailInput__XccHd","inviteButton":"SendInvitation_inviteButton__vYV5O","inviteFriendSendButton":"SendInvitation_inviteFriendSendButton__Is_6u"};

/***/ }),

/***/ 4015:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SendInvitationEmailmain":"SendinvitationEmail_SendInvitationEmailmain__XEY_e","sendInvitationEmailModalBox":"SendinvitationEmail_sendInvitationEmailModalBox__1qHm4","SendinvitationEmailModalHeding":"SendinvitationEmail_SendinvitationEmailModalHeding___ilPz","SendininvitationEmailheadingCLose":"SendinvitationEmail_SendininvitationEmailheadingCLose__sQDv3","SendinvitationEmailModelbody":"SendinvitationEmail_SendinvitationEmailModelbody__7JAkh","SendinvitationEmailModeltitle":"SendinvitationEmail_SendinvitationEmailModeltitle__jHOOs","SendInvitationEmailmodelSearchbar":"SendinvitationEmail_SendInvitationEmailmodelSearchbar__cCD97","SendInvitationEmailmodelSearcicon":"SendinvitationEmail_SendInvitationEmailmodelSearcicon__NhURq","SendinvitationEmailModelSelectedfriendnumbers":"SendinvitationEmail_SendinvitationEmailModelSelectedfriendnumbers__8sN3p","SendinvitationEmailModelSelectfriend":"SendinvitationEmail_SendinvitationEmailModelSelectfriend__ny9dd","SendinvitationEmailModelSelectallfriendcheckbox":"SendinvitationEmail_SendinvitationEmailModelSelectallfriendcheckbox__2j2DH","SendinvitationEmailModelSelectallfriendcheckboxcheck":"SendinvitationEmail_SendinvitationEmailModelSelectallfriendcheckboxcheck__zXNkf","SendinvitationEmailModelSelectallfriendcheckboxcheckedcircle":"SendinvitationEmail_SendinvitationEmailModelSelectallfriendcheckboxcheckedcircle__ghO85","SendinvitationEmailModelSelectedfriendsmainbody":"SendinvitationEmail_SendinvitationEmailModelSelectedfriendsmainbody__seGeP","SendinvitationEmailModelSelectedfriendsboxm":"SendinvitationEmail_SendinvitationEmailModelSelectedfriendsboxm__UvtlX","SendininvitationEmailLastbuttonsmain":"SendinvitationEmail_SendininvitationEmailLastbuttonsmain__N49m9"};

/***/ }),

/***/ 65638:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerWelcomeline":"HeaderWelcomeline_headerWelcomeline__CoscD","marqueeContainer":"HeaderWelcomeline_marqueeContainer__WLYiM","animated":"HeaderWelcomeline_animated__9Enh2","marquee":"HeaderWelcomeline_marquee__OXiOQ","paused":"HeaderWelcomeline_paused__OmpXo"};

/***/ })

}]);